/* BR BW - black and white redesign behaviour, 17 Sep 2026.
   1. Product page (snippets/br-pdp.liquid): gallery, options copied onto the real form,
      Add to cart taps the real submit button, description split into accordions.
   2. Product cards: photos swipe inside the card, round + adds to cart
      (a small picker opens first when the piece has sizes or other choices).
   Loaded from layout/theme.liquid. Delete the script tag there to switch it all off;
   the product page then still has the theme's own form, which assets/br-bw.css keeps
   off screen, so also remove the BR PDP block in br-bw.css if reverting. */
(function () {
  'use strict';
  var d = document;

  function money(txt) { return (txt || '').replace(/\s+/g, ' ').replace(/\.00(?!\d)/g, '').trim(); }
  function toast(msg, link) {
    var t = d.getElementById('br-toast');
    if (!t) { t = d.createElement('div'); t.id = 'br-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.innerHTML = '<span></span>' + (link ? '<a href="/cart">View bag</a>' : '');
    t.firstChild.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      d.querySelectorAll('[data-cart-count], .cart-count, .site-header__cart-count, .cart-link__count').forEach(function (n) { n.textContent = c.item_count; });
      d.dispatchEvent(new CustomEvent('br:cart', { detail: c }));
    }).catch(function () {});
  }
  function addVariant(id, btn) {
    if (btn) { btn.classList.add('is-pressed'); btn.setAttribute('aria-busy', 'true'); }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { toast('Added to bag', true); refreshCount(); })
      .catch(function (e) { if (btn) btn.classList.remove('is-pressed'); toast((e && e.description) || 'Could not add this piece'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------------- 1. PRODUCT PAGE ---------------- */
  function initPdp() {
    var root = d.getElementById('br-pdp');
    if (!root) return;
    d.body.classList.add('br-pdp-on');
    var form = d.querySelector('.adtocartmobile form.product-form') || d.querySelector('form.product-form');
    var real = form && form.querySelector('button[data-cart-submit]');
    var atc = d.getElementById('br-pdp-atc');
    var priceOut = d.getElementById('br-pdp-price');
    var priceNode = d.querySelector('.add-to-cart-placed .product__current-price') || d.querySelector('.product__current-price');
    var variants = [];
    try { variants = JSON.parse(d.getElementById('br-pdp-variants').textContent); } catch (e) {}

    /* header height, so the phone photo fills exactly the rest of the screen */
    function setTop() {
      var h = d.querySelector('.site-header') || d.querySelector('header');
      var top = h ? Math.max(0, h.getBoundingClientRect().bottom + window.pageYOffset) : 120;
      d.documentElement.style.setProperty('--br-hdr', Math.round(top) + 'px');
    }
    setTop(); window.addEventListener('load', setTop); window.addEventListener('resize', setTop);

    /* gallery */
    var track = d.getElementById('br-pdp-track');
    var slides = track ? track.children : [];
    var thumbs = root.querySelectorAll('.br-pdp__thumb');
    var lines = root.querySelectorAll('.br-pdp__lines b');
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      lines.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    function go(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    if (track) {
      var tmr;
      track.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-i'))); }); });

    /* options -> real selects */
    function selects() { return form ? form.querySelectorAll('select[data-option-input]') : []; }
    function currentVariant() {
      var chosen = [];
      selects().forEach(function (s) { chosen.push(s.value); });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < chosen.length; k++) { if (v.options[k] !== chosen[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function sync() {
      if (priceNode && priceOut) { var p = money(priceNode.textContent); if (p) priceOut.textContent = p; }
      var v = currentVariant();
      if (atc) {
        var sold = (real && real.disabled) || (v && !v.available);
        atc.disabled = !!sold;
        atc.textContent = sold ? 'Sold out' : 'Add to cart';
      }
      return v;
    }
    root.querySelectorAll('[data-br-option]').forEach(function (group) {
      var name = group.getAttribute('data-br-option');
      group.querySelectorAll('button[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          var val = b.getAttribute('data-value');
          selects().forEach(function (s) {
            if (s.name === name || s.id === name) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
          });
          group.querySelectorAll('button[data-value]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (atc) atc.classList.remove('is-pressed');
          setTimeout(function () {
            var v = sync();
            if (v && v.featured_media && track) {
              for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(v.featured_media.id)) { go(i); break; } }
            }
          }, 90);
        });
      });
    });
    if (priceNode && window.MutationObserver) new MutationObserver(sync).observe(priceNode.parentNode || priceNode, { childList: true, subtree: true, characterData: true });
    sync();

    if (atc) atc.addEventListener('click', function () {
      if (atc.disabled) return;
      atc.classList.add('is-pressed');
      if (real) { real.click(); }
      else { var v = currentVariant(); if (v) addVariant(v.id, atc); }
    });

    /* Try & Buy buttons move into the panel */
    var tb = d.querySelector('.adtocartmobile .three_btn_below_addtocart');
    var tbHome = d.getElementById('br-pdp-trybuy');
    if (tb && tbHome && tb.querySelector('a')) { tbHome.appendChild(tb); tbHome.classList.add('is-on'); }

    /* description -> accordions */
    var acc = d.getElementById('br-pdp-acc');
    if (acc) {
      var det = acc.querySelector('[data-k="details"] .br-acc__b');
      var box = { details: [], material: [], dims: [], care: [] };
      var mode = 'details';
      var nodes = Array.prototype.slice.call(det.children);
      nodes.forEach(function (n) {
        var t = (n.textContent || '').replace(/ /g, ' ').trim().toLowerCase();
        if (!t && !n.querySelector('img')) return;
        var head = t.replace(/[*:.\s]+$/, '');
        if (/^specifications?$/.test(head)) { mode = 'material'; n.remove(); return; }
        if (/^(dimensions?|size and fit|fit)$/.test(head)) { mode = 'dims'; n.remove(); return; }
        if (/^(material and fit info|material and fit|material|materials)$/.test(head)) { mode = 'material'; n.remove(); return; }
        if (/^care$/.test(head)) { mode = 'care'; n.remove(); return; }
        var target = mode;
        if (/^(length|width|height|weight|diameter|size|drop|inner diameter)\b[^a-z]{0,4}/.test(t)) target = 'dims';
        else if (/^(base material|material|type|stone|stones|finish|plating)\b\s*:/.test(t)) target = 'material';
        else if (/^care\s*:/.test(t)) target = 'care';
        else if (/^note\s*:/.test(t)) target = box.dims.length ? 'dims' : (box.material.length ? 'material' : 'details');
        box[target].push(n);
      });
      function fill(k) {
        var item = acc.querySelector('[data-k="' + k + '"]');
        if (!item || !box[k].length) return false;
        var b = item.querySelector('.br-acc__b');
        if (k === 'care') b.innerHTML = '';
        box[k].forEach(function (n) { b.appendChild(n); });
        if (k === 'care') { var p = d.createElement('p'); p.innerHTML = '<a href="/pages/jewellery-care">Jewellery care and material</a>'; b.appendChild(p); }
        item.hidden = false;
        return true;
      }
      fill('material'); fill('dims'); fill('care');
      if (!det.children.length) { var dItem = acc.querySelector('[data-k="details"]'); if (dItem) dItem.hidden = true; }
      var first = acc.querySelector('.br-acc__i:not([hidden])');
      acc.querySelectorAll('.br-acc__i').forEach(function (i) { if (i !== first) i.open = false; });
      if (window.matchMedia('(max-width: 767.98px)').matches && first) first.open = false;
    }
  }

  /* ---------------- 2. CARDS ---------------- */
  function initCards(scope) {
    (scope || d).querySelectorAll('.br-media').forEach(function (m) {
      if (m._br) return; m._br = true;
      var sc = m.querySelector('.br-media__scroll');
      var dots = m.querySelectorAll('.br-media__dots b');
      if (sc && dots.length > 1) {
        var h;
        sc.addEventListener('scroll', function () {
          clearTimeout(h);
          h = setTimeout(function () {
            var i = Math.round(sc.scrollLeft / Math.max(1, sc.clientWidth));
            dots.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
          }, 50);
        }, { passive: true });
        m.querySelectorAll('.br-media__arrow').forEach(function (a) {
          a.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var dir = a.classList.contains('br-media__arrow--next') ? 1 : -1;
            sc.scrollBy({ left: dir * sc.clientWidth, behavior: 'smooth' });
          });
        });
      }
    });
  }

  function polishOf(btn) {
    var card = btn.closest('.card, .br-best__card');
    if (!card) return 'silver';
    if (card.hasAttribute('data-polish')) return card.getAttribute('data-polish');
    var cb = card.querySelector('input.varient-col');
    return cb && cb.checked ? 'gold' : 'silver';
  }

  function openPicker(handle, btn, polish) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var sheet = d.getElementById('br-pick');
      if (!sheet) {
        sheet = d.createElement('div'); sheet.id = 'br-pick';
        sheet.innerHTML = '<div class="br-pick__bg"></div><div class="br-pick__box" role="dialog" aria-modal="true"><button type="button" class="br-pick__x" aria-label="Close">&times;</button><p class="br-pick__name"></p><p class="br-pick__price"></p><div class="br-pick__opts"></div><button type="button" class="br-pick__add">Add to cart</button></div>';
        d.body.appendChild(sheet);
        sheet.querySelector('.br-pick__bg').addEventListener('click', function () { sheet.classList.remove('is-on'); });
        sheet.querySelector('.br-pick__x').addEventListener('click', function () { sheet.classList.remove('is-on'); });
      }
      var chosen = [];
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      chosen = first.options.slice();
      p.options.forEach(function (o, i) {
        var vals = o.values.map(function (x) { return x.toLowerCase(); });
        var isPolish = vals.length === 2 && vals.join('|').indexOf('silver') > -1 && vals.join('|').indexOf('gold') > -1;
        if (isPolish) { o.values.forEach(function (x) { if (x.toLowerCase().indexOf(polish) > -1) chosen[i] = x; }); }
      });
      var optBox = sheet.querySelector('.br-pick__opts'); optBox.innerHTML = '';
      function match() { return p.variants.filter(function (v) { return v.options.every(function (x, k) { return x === chosen[k]; }); })[0]; }
      function paint() {
        var v = match(); var add = sheet.querySelector('.br-pick__add');
        sheet.querySelector('.br-pick__price').textContent = v ? 'Rs. ' + (v.price / 100).toLocaleString('en-IN') : '';
        add.disabled = !v || !v.available; add.textContent = v && !v.available ? 'Sold out' : 'Add to cart';
        add.classList.remove('is-pressed');
        optBox.querySelectorAll('button[data-i]').forEach(function (b) { b.classList.toggle('is-on', chosen[Number(b.getAttribute('data-i'))] === b.getAttribute('data-value')); });
      }
      p.options.forEach(function (o, i) {
        if (o.values.length < 2) return;
        var g = d.createElement('div'); g.className = 'br-pick__g';
        var l = d.createElement('span'); l.className = 'br-pick__l'; l.textContent = o.name; g.appendChild(l);
        var row = d.createElement('div'); row.className = 'br-chips';
        o.values.forEach(function (val) {
          var b = d.createElement('button'); b.type = 'button'; b.className = 'br-chip'; b.textContent = val;
          b.setAttribute('data-i', i); b.setAttribute('data-value', val);
          b.addEventListener('click', function () { chosen[i] = val; paint(); });
          row.appendChild(b);
        });
        g.appendChild(row); optBox.appendChild(g);
      });
      sheet.querySelector('.br-pick__name').textContent = p.title;
      var add = sheet.querySelector('.br-pick__add');
      add.onclick = function () { var v = match(); if (v && v.available) addVariant(v.id, add).then(function () { setTimeout(function () { sheet.classList.remove('is-on'); }, 700); }); };
      paint();
      sheet.classList.add('is-on');
      if (btn) btn.classList.remove('is-pressed');
    }).catch(function () { window.location.href = '/products/' + handle; });
  }

  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.br-qa');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var polish = polishOf(btn);
    if (btn.getAttribute('data-simple') === '1') {
      var id = (polish === 'gold' ? btn.getAttribute('data-gold') : btn.getAttribute('data-silver')) || btn.getAttribute('data-first');
      if (id) { addVariant(id, btn); return; }
    }
    btn.classList.add('is-pressed');
    openPicker(btn.getAttribute('data-handle'), btn, polish);
  }, true);


  /* ---------------- 3. WISHLIST (saved in this browser) ----------------
     The Swym / Wishlist Hero apps are not running on the store, so the hearts keep their own list
     in localStorage and /pages/swym-wishlist shows it whenever the Swym container stays empty. */
  var WKEY = 'brWishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function wlPaint() {
    var a = wlGet();
    d.querySelectorAll('.br-wish[data-handle]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.br-wish[data-handle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle'), a = wlGet(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.push(h); toast('Saved to wishlist'); }
    wlSet(a); wlPaint();
  }, true);
  function wlPage() {
    var box = d.getElementById('swym-wishlist-render-container');
    if (!box) return;
    setTimeout(function () {
      if (box.children.length || window._swat) return;
      var a = wlGet();
      box.classList.add('br-wl');
      if (!a.length) { box.innerHTML = '<p class="br-wl__empty">Your wishlist is empty. Tap the heart on any piece to save it here.</p>'; return; }
      box.innerHTML = '';
      a.forEach(function (h) {
        fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          var el = d.createElement('div'); el.className = 'br-wl__item';
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          el.innerHTML = '<a href="/products/' + p.handle + '" class="br-media br-wl__img"><img alt="" loading="lazy"></a><div class="br-wl__name"></div><div class="br-wl__row"><span class="br-wl__price"></span><button type="button" class="br-wish is-on" data-handle="' + p.handle + '" aria-label="Remove from wishlist"></button></div>';
          if (img) el.querySelector('img').src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          el.querySelector('.br-wl__name').textContent = p.title;
          el.querySelector('.br-wl__price').textContent = 'Rs. ' + (p.price / 100).toLocaleString('en-IN');
          box.appendChild(el); wlPaint();
        });
      });
    }, 2500);
  }

  /* phone product page: lift the floating app buttons above the buying sheet */
  function liftFloats() {
    if (!d.getElementById('br-pdp') || !window.matchMedia('(max-width: 767.98px)').matches) return;
    [['shopify-chat', '.activator-nudge{ transform:translateY(-236px) !important }'], ['gty-whatsapp-chat-button', '.gty-wacb-wrapper{ bottom:272px !important }']].forEach(function (cfg) {
      var tries = 0;
      (function attempt() {
        var host = d.querySelector(cfg[0]);
        if (host && host.shadowRoot) {
          if (!host.shadowRoot.getElementById('br-bw-lift')) { var s = d.createElement('style'); s.id = 'br-bw-lift'; s.textContent = cfg[1]; host.shadowRoot.appendChild(s); }
          return;
        }
        if (++tries < 40) setTimeout(attempt, 250);
      })();
    });
  }

  /* BR BW FIXES 2, 17 Sep 2026 */
  function brFix2() {
    var main = d.querySelector('.br-pdp__main'), first = d.querySelector('.br-pdp__slide img[width][height]');
    if (main && first) { var w = +first.getAttribute('width'), h = +first.getAttribute('height'); if (w && h) { main.style.setProperty('--br-ar', w + ' / ' + h); main.style.setProperty('--br-arn', (w / h).toFixed(4)); } }
    var sx = 0, sy = 0;
    d.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true, capture: true });
    function go(e, x, y) {
      var el = e.target.closest && e.target.closest('.br-stare-mark, .br-has-mark, .br-slide-link');
      if (!el) return;
      var a = el.closest('a') || el.parentNode.querySelector('a.br-slide-link') || (el.closest('.slideshow__slide') || d).querySelector('a.br-slide-link, a.cta_link');
      if (!a || !a.getAttribute('href')) return;
      if (x !== undefined && (Math.abs(x - sx) > 10 || Math.abs(y - sy) > 10)) return;
      e.preventDefault(); e.stopPropagation(); location.href = a.getAttribute('href');
    }
    d.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; go(e, t.clientX, t.clientY); }, { capture: true });
    d.addEventListener('click', function (e) { go(e); }, true);
    /* currency pill: the app scales it and overrides stylesheet offsets, so line it up by measuring:
       centred on WhatsApp's centre line, 12px above the language button */
    var cn = 0;
    (function pinCur() {
      var c = d.querySelector('.buckscc-currency-wrapper'), l = d.querySelector('.eat-languageSelector');
      if (c && l && l.offsetWidth) {
        ['top', 'left', 'transform'].forEach(function (p) { c.style.setProperty(p, p === 'transform' ? 'none' : 'auto', 'important'); });
        var cs = getComputedStyle(c), lr = l.getBoundingClientRect(), cr = c.getBoundingClientRect();
        var right = parseFloat(cs.right) || 0, bottom = parseFloat(cs.bottom) || 0;
        var axis = lr.left + lr.width / 2;
        right += (cr.left + cr.width / 2) - axis;
        bottom += cr.bottom - (lr.top - 12);
        c.style.setProperty('right', right.toFixed(1) + 'px', 'important');
        c.style.setProperty('bottom', bottom.toFixed(1) + 'px', 'important');
      }
      if (++cn < 40) setTimeout(pinCur, 300);
    })();
    var cfgs = [['shopify-chat', '.activator-nudge{ transform:none !important; left:16px !important; right:auto !important; bottom:calc(var(--br-dock, 0px) + 20px) !important; }'],
      ['gty-whatsapp-chat-button', '.gty-wacb-wrapper{ transform:none !important; top:auto !important; left:auto !important; right:20px !important; bottom:calc(var(--br-dock, 0px) + 20px) !important; width:52px !important; height:52px !important; } .gty-wacb-button-container, .gty-wacb-button{ width:52px !important; height:52px !important; } .gty-wacb-button svg{ width:26px !important; height:26px !important; }']];
    cfgs.forEach(function (cfg) {
      var tries = 0;
      (function attempt() {
        var host = d.querySelector(cfg[0]);
        if (host && host.shadowRoot) {
          var s = host.shadowRoot.getElementById('br-bw-lift');
          if (!s) { s = d.createElement('style'); s.id = 'br-bw-lift'; host.shadowRoot.appendChild(s); }
          s.textContent = cfg[1];
          return;
        }
        if (++tries < 60) setTimeout(attempt, 250);
      })();
    });
  }

  /* BR INR NOTE, Sep 2026 (Vikas approved product, collection and cart notes, 17 Sep 2026): when a visitor views prices in another currency via the
     BUCKS converter, say plainly that the price is approximate and that checkout charges Indian rupees. */
  function brInrNote() {
    var fmt = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
    function cur() {
      var m = d.querySelector('.money[bucks-currency]');
      if (m && /^[A-Z]{3}$/.test(m.getAttribute('bucks-currency'))) return m.getAttribute('bucks-currency');
      try { var a = JSON.parse(localStorage.getItem('buckscc_last_manual') || 'null'), b = JSON.parse(localStorage.getItem('buckscc_auto_currency') || 'null'); var x = (a && b) ? (a.timestamp > b.timestamp ? a : b) : (a || b); return (x && x.currency) || 'INR'; } catch (e) { return 'INR'; }
    }
    function put(anchor, id, html, after) {
      if (!anchor) return;
      var el = d.getElementById(id);
      if (!el) { el = d.createElement('p'); el.id = id; el.className = 'br-inr-note'; if (after) anchor.parentNode.insertBefore(el, anchor.nextSibling); else anchor.parentNode.insertBefore(el, anchor); }
      if (el.innerHTML !== html) el.innerHTML = html;
    }
    function drop(id) { var el = d.getElementById(id); if (el) el.remove(); }
    var cartInr = null, cartAt = 0;
    function tick() {
      var c = cur(), foreign = c !== 'INR';
      /* product page */
      var row = d.querySelector('.br-pdp__row2');
      if (row) {
        if (foreign) {
          var inr = null, sel = d.querySelector('form.product-form [name="id"]'), vj = d.getElementById('br-pdp-variants');
          try { var vs = JSON.parse(vj.textContent); var v = vs.filter(function (x) { return String(x.id) === String(sel && sel.value); })[0] || vs[0]; inr = v.price / 100; } catch (e) {}
          put(row, 'br-inr-pdp', 'Approx. price in ' + c + '. You pay <b>' + (inr ? fmt(inr) : 'in Indian rupees') + '</b> (Indian rupees) at checkout.', true);
        } else drop('br-inr-pdp');
      }
      /* collection and search pages */
      var bar = d.querySelector('.template-collection .collection-dropdowns, .template-search .search-results-header, .template-search .section-header');
      if (bar) { if (foreign) put(bar, 'br-inr-coll', 'Prices in ' + c + ' are approximate. You pay in Indian rupees (INR) at checkout.', true); else drop('br-inr-coll'); }
      /* cart page and cart drawer: above the checkout button */
      var btn = d.querySelector('.cart__checkout, .cart-drawer__checkout, form[action="/cart"] [name="checkout"]');
      if (btn) {
        if (foreign) {
          if (Date.now() - cartAt > 4000) { cartAt = Date.now(); fetch('/cart.js').then(function (r) { return r.json(); }).then(function (j) { cartInr = j.total_price / 100; }).catch(function () {}); }
          put(btn, 'br-inr-cart', 'At checkout you pay in Indian rupees: <b>' + (cartInr != null ? fmt(cartInr) : 'INR') + '</b> + shipping. Your bank converts it to ' + c + ', so your statement may differ slightly from the prices shown here.', false);
        } else drop('br-inr-cart');
      }
    }
    tick(); setInterval(tick, 800);
  }

  /* BR CART COUNT, Sep 2026: number of items on the bag icon (header and scroll-up bar).
     The theme's own bubble span is misspelt (site-header_cart-bubble) so nothing ever lit it up. */
  function brCartCount() {
    var busy = false, last = -1;
    function paint(n) {
      last = n;
      d.querySelectorAll('.site-header a[href="/cart"], .br-sticky__cart').forEach(function (a) {
        var b = a.querySelector('.br-cart-count');
        if (!b) { b = d.createElement('span'); b.className = 'br-cart-count'; b.setAttribute('aria-hidden', 'true'); a.appendChild(b); }
        b.textContent = n > 99 ? '99+' : String(n);
        b.classList.toggle('is-on', n > 0);
        a.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart');
      });
    }
    function refresh() {
      if (busy) return; busy = true;
      (window.__brFetch || fetch)('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (j) { paint(j.item_count || 0); }).catch(function () {}).then(function () { busy = false; });
    }
    var isCart = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };
    if (!window.__brFetch) {
      window.__brFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var p = window.__brFetch(input, init);
        var u = typeof input === 'string' ? input : (input && input.url);
        if (isCart(u)) p.then(function () { setTimeout(refresh, 150); }, function () {});
        return p;
      };
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, u) {
        if (isCart(u)) this.addEventListener('loadend', function () { setTimeout(refresh, 150); });
        return open.apply(this, arguments);
      };
    }
    d.addEventListener('visibilitychange', function () { if (!d.hidden) refresh(); });
    window.addEventListener('pageshow', refresh);
    refresh();
  }

  /* BR SALE NOTE, 17 Sep 2026: weekend sale line on the cart page and in the cart drawer.
     The cart template has no discount line of its own, so the tier is worked out from the
     cart subtotal and matches the four automatic discounts in Shopify.
     Shows itself only between the sale start and end; after that nothing renders. */
  function brSaleNote() {
    var START = new Date('2026-09-17T18:31:00Z'), END = new Date('2026-09-21T06:59:59Z');
    var TIERS = [[70000, 20], [45000, 15], [20000, 10], [0, 5]];
    var ENDS = 'Monday 21 September, 12:30 pm';
    var fmt = function (n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); };
    var busy = false, last = '';
    function tier(sub) { for (var i = 0; i < TIERS.length; i++) { if (sub >= TIERS[i][0]) return TIERS[i]; } return TIERS[TIERS.length - 1]; }
    function next(sub) { for (var i = TIERS.length - 1; i >= 0; i--) { if (TIERS[i][0] > sub) return TIERS[i]; } return null; }
    function drop() { var e = d.getElementById('br-sale'); if (e) e.remove(); }
    function render(sub) {
      var btn = d.querySelector('.cart__checkout, .cart-drawer__checkout, form[action="/cart"] [name="checkout"]');
      if (!btn || !sub) { drop(); return; }
      var t = tier(sub), n = next(sub);
      var html = '<p class="br-sale__k">Weekend sale</p>' +
        '<p class="br-sale__m"><b>' + t[1] + '% off</b> this order \u00B7 you save <b>' + fmt(sub * t[1] / 100) + '</b></p>' +
        (n ? '<p class="br-sale__n">Add ' + fmt(n[0] - sub) + ' more for ' + n[1] + '% off.</p>' : '') +
        '<ul class="br-sale__t"><li>Up to \u20B919,999 \u2014 5%</li><li>\u20B920,000 \u2013 \u20B944,999 \u2014 10%</li><li>\u20B945,000 \u2013 \u20B969,999 \u2014 15%</li><li>\u20B970,000 and above \u2014 20%</li></ul>' + '<p class="br-sale__s">Ends ' + ENDS + '.</p>';
      var el = d.getElementById('br-sale');
      if (!el) { el = d.createElement('div'); el.id = 'br-sale'; el.className = 'br-sale'; var anc = btn.closest('.btn-group') || btn; anc.parentNode.insertBefore(el, anc); }
      if (html !== last) { el.innerHTML = html; last = html; }
    }
    function tick() {
      var now = new Date();
      if (now < START || now > END) { drop(); return; }
      if (!d.querySelector('.cart__checkout, .cart-drawer__checkout, form[action="/cart"] [name="checkout"]')) return;
      if (busy) return; busy = true;
      (window.__brFetch || fetch)('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (j) { render((j.items_subtotal_price || j.total_price || 0) / 100); })
        .catch(function () {}).then(function () { busy = false; });
    }
    tick();
    setInterval(tick, 2500);
  }

  /* BR SALE POPUP, 18 Sep 2026: weekend sale banner shown once per visit, inside the sale window only. */
  function brSalePop() {
    var START = new Date('2026-09-17T18:31:00Z'), END = new Date('2026-09-21T06:59:59Z');
    var now = new Date();
    if (now < START || now > END) return;
    try { if (sessionStorage.getItem('brSalePop') === '1') return; } catch (e) {}
    if (/\/(cart|checkouts)/.test(location.pathname)) return;
    var w = d.createElement('div');
    w.id = 'br-pop';
    w.innerHTML =
      '<div class="br-pop__bg"></div>' +
      '<div class="br-pop__box br-pop__box--img" role="dialog" aria-label="Weekend sale">' +
        '<button class="br-pop__x" type="button" aria-label="Close">&times;</button>' +
        '<img class="br-pop__img" src="https://cdn.shopify.com/s/files/1/2675/8584/files/Sale_banner_E_luxe_compact_10bb5493-19b9-43af-a729-15e1989cc2b9.png?v=1789669496&width=1400" alt="Upto 20% off sale, online 18th to 20th September. Up to Rs 19,999 5% off, Rs 20,000 to Rs 44,999 10% off, Rs 45,000 to Rs 69,999 15% off, Rs 70,000 and above 20% off. Discount applied directly at checkout.">' +
        '<a class="br-pop__cta" href="/collections/shop-all">Shop Sale</a>' +
      '</div>';
    d.body.appendChild(w);
    try { sessionStorage.setItem('brSalePop', '1'); } catch (e) {}
    var close = function () { w.classList.add('is-off'); setTimeout(function () { w.remove(); }, 250); };
    w.querySelector('.br-pop__x').addEventListener('click', close);
    w.querySelector('.br-pop__bg').addEventListener('click', close);
    w.querySelector('.br-pop__cta').addEventListener('click', close);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    requestAnimationFrame(function () { w.classList.add('is-on'); });
  }

  /* BR GOOD TO KNOW, 18 Sep 2026: five tiles under the product accordions.
     The old theme tab row (pro-dr-tabs-info-out) is hidden in the black & white design; this
     brings back the five useful panels. The panel's ORIGINAL node is moved into the sheet so the
     COD pincode checker keeps working, and moved back when the sheet closes. */
  function brTrust() {
    if (!d.querySelector('.br-pdp__main')) return;
    if (d.querySelector('.br-trust')) return;
    var last = [].slice.call(d.querySelectorAll('.br-pdp__acc details, details')).pop();
    if (!last) return;
    var ICON = {
      cod: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="3"/></svg>',
      cert: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="9" r="5"/><path d="M8.5 13.5 7 22l5-2.5L17 22l-1.5-8.5"/></svg>',
      hand: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3c2.5 3 5 5 5 8a5 5 0 0 1-10 0c0-3 2.5-5 5-8z"/></svg>',
      gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M3 13h18M12 9v12M12 9c-2 0-4-1-4-3s3-1 4 3c1-4 4-5 4-3s-2 3-4 3z"/></svg>',
      faq: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.3"/><circle cx="12" cy="17" r=".6" fill="#fff" stroke="none"/></svg>'
    };
    var ITEMS = [
      ['Pay on delivery', ICON.cod, 'Pay on delivery', 'HTML:<p>Pay for your order when it reaches your door \u2014 available on orders <b>within India</b> only.<\/p><p>Cash on delivery is offered on orders between <b>\u20B96,000 and \u20B99,000<\/b>. Below or above that, orders are prepaid (UPI, cards, wallets, international cards).<\/p><p>International orders are prepaid only.<\/p>'],
      ['925 silver certificate', ICON.cert, 'Certificate of authenticity', '.cc-modal-window__content_cert-cls'],
      ['Handmade in Jaipur', ICON.hand, 'Handmade in Jaipur', '.cc-modal-window__content-handmade-cls'],
      ['Gift wrapping', ICON.gift, 'Gift wrap', '.cc-modal-window__content-gift_wrap-cls'],
      ['Product FAQ<span class="brfaq-s">s</span>', ICON.faq, 'Product FAQs', '.cc-modal-window__content-faqs-cls']
    ].filter(function (it) { return it[3].indexOf('HTML:') === 0 || d.querySelector(it[3]); });
    if (!ITEMS.length) return;
    var wrap = d.createElement('div');
    wrap.className = 'br-trust';
    wrap.innerHTML = '<p class="br-trust__k">Good to know</p><div class="br-trust__grid">' +
      ITEMS.map(function (it, i) { return '<button class="br-trust__t" type="button" data-i="' + i + '">' + it[1] + '<span>' + it[0] + '</span></button>'; }).join('') +
      '</div>';
    last.parentNode.insertBefore(wrap, last.nextSibling);
    var sh = d.createElement('div');
    sh.id = 'br-sheet';
    sh.innerHTML = '<div class="bg"></div><div class="box" role="dialog"><button class="x" type="button" aria-label="Close">&times;</button><h3></h3><div class="c"></div></div>';
    d.body.appendChild(sh);
    var home = null, node = null;
    function close() {
      sh.classList.remove('is-on');
      if (node && home) { home.appendChild(node); }
      node = null; home = null;
      d.documentElement.style.overflow = '';
    }
    sh.querySelector('.bg').addEventListener('click', close);
    sh.querySelector('.x').addEventListener('click', close);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    wrap.querySelectorAll('.br-trust__t').forEach(function (b) {
      b.addEventListener('click', function () {
        var it = ITEMS[+b.dataset.i];
        var c0 = sh.querySelector('.c');
        if (it[3].indexOf('HTML:') === 0) {
          if (node && home) home.appendChild(node);
          node = null; home = null;
          sh.querySelector('h3').textContent = it[2];
          c0.innerHTML = it[3].slice(5);
          sh.classList.add('is-on');
          d.documentElement.style.overflow = 'hidden';
          return;
        }
        var el = d.querySelector(it[3]);
        if (!el) return;
        if (node && home) home.appendChild(node);
        home = el.parentNode; node = el;
        sh.querySelector('h3').textContent = it[2];
        var c = sh.querySelector('.c');
        c.innerHTML = '';
        c.appendChild(el);
        sh.classList.add('is-on');
        d.documentElement.style.overflow = 'hidden';
      });
    });
  }

  function brUtil() {
    var u = d.querySelector('.br-util'); if (!u) return;
    var line = u.querySelector('.br-util__line'); if (!line) return;
    if (line.querySelector('.br-shop')) { u.classList.add('br-util--one'); return; }
    var bou = u.querySelector('.br-util__boutique');
    var href = (bou && bou.getAttribute('href')) || '/pages/retail-store';
    line.innerHTML = 'Handcrafted in Jaipur \u00b7 <a class="br-shop" href="' + href + '">Our stores <span aria-hidden="true">&#8594;</span></a> \u00b7 Ships worldwide';
    u.classList.add('br-util--one');
  }

  function brFly() {
    try { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    function cartEl() { return d.querySelector('.site-header a[href*="/cart"]') || d.querySelector('.site-header [class*="cart"]'); }
    function imgFor(btn) {
      var card = btn.closest ? btn.closest('.card, .grid-product, .br-best__item, .card-list__column') : null;
      var im = card ? card.querySelector('img') : null;
      if (!im) im = d.querySelector('.br-pdp__slide img, .br-pdp__main img, .product-single__photo img, .product__photo img');
      return im;
    }
    function fly(im) {
      var cart = cartEl(); if (!im || !cart) return;
      var s = im.getBoundingClientRect(), c = cart.getBoundingClientRect();
      if (!s.width || !c.width) return;
      var size = Math.min(s.width, s.height, 150); if (size < 44) size = 88;
      var x0 = s.left + s.width / 2, y0 = s.top + s.height / 2;
      var x1 = c.left + c.width / 2, y1 = c.top + c.height / 2;
      var g = d.createElement('img'); g.className = 'br-fly'; g.setAttribute('alt', '');
      g.src = im.currentSrc || im.src;
      g.style.width = size + 'px'; g.style.height = size + 'px';
      g.style.left = (x0 - size / 2) + 'px'; g.style.top = (y0 - size / 2) + 'px';
      d.body.appendChild(g);
      var t0 = null, DUR = 640, lift = Math.max(70, Math.min(170, (y0 - y1) * 0.34));
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / DUR);
        var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        var x = x0 + (x1 - x0) * e;
        var y = y0 + (y1 - y0) * e - Math.sin(Math.PI * e) * lift;
        var sc = 1 - 0.82 * e;
        g.style.transform = 'translate(' + (x - x0) + 'px,' + (y - y0) + 'px) scale(' + sc + ') rotate(' + (e * -16) + 'deg)';
        g.style.opacity = String(k < 0.86 ? 1 : (1 - (k - 0.86) / 0.14));
        if (k < 1) requestAnimationFrame(step);
        else {
          if (g.parentNode) g.parentNode.removeChild(g);
          var ci = cartEl();
          if (ci) { ci.classList.remove('br-cartpulse'); void ci.offsetWidth; ci.classList.add('br-cartpulse'); setTimeout(function () { ci.classList.remove('br-cartpulse'); }, 700); }
        }
      }
      requestAnimationFrame(step);
    }
    d.addEventListener('click', function (ev) {
      var t = ev.target; if (!t || !t.closest) return;
      var b = t.closest('button[name="add"], .br-qa, .btn--add-to-cart, .product-form__cart-submit, .add-to-cart, [data-br-add]');
      if (!b || b.disabled) return;
      var im = imgFor(b); if (im) fly(im);
    }, true);
  }

  function boot() { initPdp(); initCards(); wlPaint(); wlPage(); brFix2(); brInrNote(); brCartCount(); brSaleNote(); brSalePop(); brTrust(); brUtil(); brFly(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.BRBW = { initCards: initCards };
})();


/* ===== BR LIST1 26 SEP =====
   Vikas approved list 1 (points 1-6) of new-website-changes-before-after-22sep2026.pdf on 26 Sep 2026.
   Appended after the main br-bw.js IIFE; its CSS is the "BR LIST1 26 SEP" block at the end of assets/br-bw.css.
   Runs after the page's own brUtil() (same boot order: this file's DOMContentLoaded listener is registered after
   the main one) and also waits for it if needed. Delete this block and the CSS block to undo. Prefix: brn- */
(function () {
  'use strict';

  /* ---- THE ONE SWITCH: top line on phones ----
     'two' = approved default: "HANDCRAFTED IN STERLING SILVER" on two lines each side of the centred pill (30px row)
     'A'   = his exact words on ONE line, letter size auto-fitted (about 7.5px on a 390px phone)
     'B'   = one line, the pill reads "STORES ->" (about 8.25px on a 390px phone)
     'C'   = one line, "HANDCRAFTED 925 SILVER" (9px on every phone)
     Desktop is the same for all four. */
  var BRN_TOPLINE = 'two';

  var d = document;
  var TOP = {
    two: { left: 'Handcrafted in Sterling Silver', pill: 'Our stores', one: false },
    A:   { left: 'Handcrafted in Sterling Silver', pill: 'Our stores', one: true },
    B:   { left: 'Handcrafted in Sterling Silver', pill: 'Stores',     one: true },
    C:   { left: 'Handcrafted 925 Silver',         pill: 'Our stores', one: true }
  };
  var RIGHT = 'Ships worldwide';

  /* 1 · Sort: make each sort select exactly as wide as its chosen option, so the caret sits right after the text */
  function brNewSort() {
    var sels = d.querySelectorAll('select.collection-sort__input');
    if (!sels.length) return;
    var PROPS = ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'fontVariant', 'fontStretch', 'letterSpacing', 'wordSpacing', 'textTransform', 'fontFeatureSettings', 'fontKerning'];
    function fit(sel) {
      try {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var s = getComputedStyle(sel), sp = d.createElement('span');
        sp.textContent = opt.text;
        sp.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:0;white-space:pre;padding:0;margin:0;border:0';
        PROPS.forEach(function (p) { try { sp.style[p] = s[p]; } catch (e) {} });
        d.body.appendChild(sp);
        var tw = sp.getBoundingClientRect().width;
        sp.parentNode.removeChild(sp);
        if (!(tw > 0)) return;
        var pad = (parseFloat(s.paddingLeft) || 0) + (parseFloat(s.paddingRight) || 0) + (parseFloat(s.borderLeftWidth) || 0) + (parseFloat(s.borderRightWidth) || 0);
        sel.style.setProperty('width', Math.ceil((s.boxSizing === 'content-box' ? tw : tw + pad) + 2) + 'px', 'important');
      } catch (e) {}
    }
    function all() { Array.prototype.forEach.call(sels, fit); }
    Array.prototype.forEach.call(sels, function (s) { s.addEventListener('change', function () { fit(s); }); });
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 150); });
    try { if (d.fonts && d.fonts.ready) d.fonts.ready.then(all); } catch (e) {}
    all();
  }

  /* 2 · Announcement line: left text / "Our stores" pill in the exact centre / right text.
     Must run after brUtil() in the main IIFE (it writes the pill link the href is taken from); if the pill is not
     there yet it waits up to 2 seconds, then builds the line anyway from the "Our stores" link above it. */
  function brNewUtil(tries) {
    try {
      var line = d.querySelector('.br-util .br-util__line');
      if (!line || line.querySelector('.brn-c')) return;
      var shop = line.querySelector('a.br-shop');
      if (!shop && (tries || 0) < 40) { setTimeout(function () { brNewUtil((tries || 0) + 1); }, 50); return; }
      var root = line.closest('.br-util');
      var bou = root && root.querySelector('.br-util__boutique');
      var href = (shop && shop.getAttribute('href')) || (bou && bou.getAttribute('href')) || '/pages/retail-store';
      var cfg = TOP[BRN_TOPLINE] || TOP.two;
      var l = d.createElement('span'); l.className = 'brn-l'; l.textContent = cfg.left;
      var c = d.createElement('a'); c.className = 'br-shop brn-c'; c.setAttribute('href', href);
      c.appendChild(d.createTextNode(cfg.pill + ' '));
      var ar = d.createElement('span'); ar.setAttribute('aria-hidden', 'true'); ar.textContent = '→'; c.appendChild(ar);
      var r = d.createElement('span'); r.className = 'brn-r'; r.textContent = RIGHT;
      while (line.firstChild) line.removeChild(line.firstChild);
      line.appendChild(l); line.appendChild(d.createTextNode(' ')); line.appendChild(c); line.appendChild(d.createTextNode(' ')); line.appendChild(r);
      line.classList.add('brn-line');
      if (root) { root.classList.add('brn-util'); root.classList.add('br-util--one'); }
      if (cfg.one) {
        line.classList.add('brn-nowrap');
        if (root) root.classList.add('brn-util--one');
        /* phones and tablets: largest letter size (max 9px) at which both side texts fit on one line */
        var fitLine = function () {
          try {
            var els = [l, r, c];
            if (d.documentElement.clientWidth > 1024) { els.forEach(function (e) { e.style.removeProperty('font-size'); }); return; }
            var fs = 9;
            var set = function (v) { els.forEach(function (e) { e.style.setProperty('font-size', v + 'px', 'important'); }); };
            var fits = function () { return l.scrollWidth <= l.clientWidth + 0.5 && r.scrollWidth <= r.clientWidth + 0.5; };
            set(fs);
            while (!fits() && fs > 6) { fs -= 0.25; set(fs); }
          } catch (e) {}
        };
        var t;
        window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitLine, 120); });
        try { if (d.fonts && d.fonts.ready) d.fonts.ready.then(fitLine); } catch (e) {}
        fitLine();
      }
    } catch (e) {}
  }

  /* 3 · Header: 44px tap targets around the burger, search and bag (main header and #br-sticky), without moving
     them; the scroll-up bar's logo gets the brn-slogo class (32px on phones, 34px on desktop, see the CSS). */
  function brNewHeader() {
    function free(el, p) { var c = getComputedStyle(el, p).content; return !c || c === 'none' || c === 'normal'; }
    ['.site-header .site-header__navigation', 'button.search-toggle-btn', 'a.site-header_cart',
     '#br-sticky .br-sticky__burger', '#br-sticky .br-sticky__search', '#br-sticky .br-sticky__cart'].forEach(function (sel) {
      Array.prototype.forEach.call(d.querySelectorAll(sel), function (el) {
        try {
          var b = el.getBoundingClientRect();
          if (b.width >= 44 && b.height >= 44) return;
          var cls = free(el, '::after') ? 'brn-hit' : (free(el, '::before') ? 'brn-hit-b' : '');
          if (!cls) return;
          if (getComputedStyle(el).position === 'static') el.classList.add('brn-rel');
          el.classList.add(cls);
        } catch (e) {}
      });
    });
    try {
      var logo = d.querySelector('#br-sticky img[src*="logo"], #br-sticky img[class*="logo"], #br-sticky a[href="/"] img');
      if (logo) logo.classList.add('brn-slogo');
    } catch (e) {}
  }

  /* 4 · Collection pages: page numbers become one "More 18 / 229" pill that loads the next page into the grid.
     The theme's .pagination stays in the HTML (hidden) so crawlers still follow ?page=N. */
  function brNewMore() {
    var SECS = ['#shopify-section-collection-template', '.collection-template', '[data-section-type="collection-template"]'];
    var PER = 18;
    function pageOf(u) { var m = /[?&]page=(\d+)/.exec(u || ''); return m ? parseInt(m[1], 10) : 1; }
    function abs(h, base) { try { return new URL(h, base).href; } catch (e) { return null; } }
    function isCard(c) { return c.nodeType === 1 && (c.matches('a[href*="/products/"]') || !!c.querySelector('a[href*="/products/"]')); }
    function cardsOf(g) { return g ? Array.prototype.filter.call(g.children, isCard) : []; }
    function section(pag, doc) {
      var i, s;
      if (pag) for (i = 0; i < SECS.length; i++) { s = pag.closest(SECS[i]); if (s) return s; }
      for (i = 0; i < SECS.length; i++) { s = doc.querySelector(SECS[i]); if (s) return s; }
      return doc.querySelector('main') || doc.body;
    }
    function allCols(g) {
      var list = g && g.parentElement;
      if (list && list.classList && list.classList.contains('card-list')) {
        var cols = Array.prototype.filter.call(list.children, function (c) { return c.classList && c.classList.contains('card-list__column'); });
        if (cols.length) return cols;
      }
      return g ? [g] : [];
    }
    function allCards(g) { var out = []; allCols(g).forEach(function (c) { out = out.concat(cardsOf(c)); }); return out; }
    /* same rule as the theme's _positionCard: shortest column, leftmost within 150px */
    function placeCard(g, card) {
      var cols = allCols(g);
      if (cols.length < 2) { (cols[0] || g).appendChild(card); return; }
      var hs = cols.map(function (c) { return c.getBoundingClientRect().height; });
      var r = hs.indexOf(Math.min.apply(Math, hs));
      for (var o = 0; o < hs.length; o++) { if (hs[r] > hs[o] - 150) { r = o; break; } }
      cols[r].appendChild(card);
    }
    /* pieces loaded by More: reveal, photo swipe, Silver/Gold switch (custom.js binds .varient-col only at page load) */
    function wireCards(cards) {
      cards.forEach(function (c) { (c.classList.contains('card') ? [c] : Array.prototype.slice.call(c.querySelectorAll('.card'))).forEach(function (x) { x.classList.add('card--reveal', 'has-animated'); }); });
      try { if (window.BRBW && window.BRBW.initCards) window.BRBW.initCards(d); } catch (e) {}
      try {
        var $ = window.jQuery; if (!$) return;
        $(cards).find('.varient-col').off('click.brnew').on('click.brnew', function () {
          var cv = '', ps = '', proid = $(this).parents('.varient-gee').attr('product-id');
          if (this.checked) { cv = $(this).attr('gold-variant-id'); ps = $(this).attr('gold-variant-price'); } else { cv = $(this).attr('silver-variant-id'); ps = $(this).attr('silver-variant-price'); }
          $('.pro-mainimg-' + proid + 'img').removeClass('variant-img-active'); $('.hidden-pro-var').removeClass('variant-img-active');
          $('.prodvariant-img-' + cv).addClass('variant-img-active'); $('.propriceproid-' + proid).html(ps);
        });
      } catch (e) {}
    }
    function findGrid(pag, doc) {
      var sec = section(pag, doc), best = null, bestN = 0, seen = [];
      Array.prototype.forEach.call(sec.querySelectorAll('a[href*="/products/"]'), function (a) {
        for (var el = a; el && el !== sec; el = el.parentElement) {
          var p = el.parentElement;
          if (!p || seen.indexOf(p) !== -1) continue;
          seen.push(p);
          var n = cardsOf(p).length;
          if (n > bestN) { bestN = n; best = p; }
        }
      });
      return best;
    }
    function nextHref(pag, base) {
      if (!pag) return null;
      var cur = pageOf(base), best = null, as = pag.querySelectorAll('a[href]');
      for (var i = 0; i < as.length; i++) {
        var h = abs(as[i].getAttribute('href'), base);
        if (!h) continue;
        if (as[i].getAttribute('rel') === 'next' || as[i].querySelector('.icon-arrow-right') || /\bnext\b/i.test(as[i].textContent)) return h;
        if (pageOf(h) === cur + 1) best = h;
      }
      return best;
    }
    function keyOf(c) {
      var a = c.matches('a[href*="/products/"]') ? c : c.querySelector('a[href*="/products/"]');
      var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
      return m ? m[1] : null;
    }
    var REVEAL = /(visible|animate|reveal|in-?view|appear|shown|loaded|fade|show)/i;
    function hidden(s) { return parseFloat(s.opacity) < 0.05 || s.visibility === 'hidden' || (s.transform && s.transform !== 'none'); }
    function reveal(added, ref) {
      if (!ref) return;
      added.forEach(function (nc) {
        [[ref, nc], [ref.firstElementChild, nc.firstElementChild]].forEach(function (p) {
          var a = p[0], b = p[1];
          if (!a || !b || hidden(getComputedStyle(a)) || !hidden(getComputedStyle(b))) return;
          Array.prototype.forEach.call(a.classList, function (c) { if (REVEAL.test(c)) b.classList.add(c); });
          if (hidden(getComputedStyle(b))) { b.style.opacity = '1'; b.style.transform = 'none'; b.style.visibility = 'visible'; }
        });
      });
    }

    try {
      var pag = d.querySelector('#shopify-section-collection-template .pagination, [data-section-type="collection-template"] .pagination, .collection-template .pagination');
      if (!pag || (pag.nextElementSibling && pag.nextElementSibling.classList.contains('brn-more'))) return;
      var grid = findGrid(pag, d);
      var next = nextHref(pag, location.href);
      if (!grid || !next) return;
      /* the theme rebuilds its columns from its own card list when the window crosses the phone/desktop width
         (theme.min.js _replaceColumns), so the grid element can be replaced and pieces added by More dropped */
      var extra = [];
      function liveGrid() {
        if (!d.documentElement.contains(grid)) grid = findGrid(pag, d) || grid;
        return grid;
      }
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          var lost = extra.filter(function (c) { return !d.documentElement.contains(c); });
          if (!lost.length) return;
          var g = liveGrid();
          lost.forEach(function (c) { placeCard(g, c); });
          wireCards(lost); /* jQuery .html() cleared their Silver/Gold handlers */
        }, 60);
      });
      var countEl = d.querySelector('.collection-dropdowns .br-count, .br-count');
      var tm = countEl && /(\d[\d,.\s]*)/.exec(countEl.textContent);
      var total = tm ? parseInt(tm[1].replace(/[^\d]/g, ''), 10) || 0 : 0;
      var start = pageOf(location.href);
      var shown = Math.min((start - 1) * PER + allCards(grid).length, total || Infinity);
      if (total && shown >= total) return;

      var wrap = d.createElement('div');
      wrap.className = 'brn-more';
      wrap.innerHTML = '<a class="brn-more__btn"><span class="brn-more__t">More</span> <span class="brn-more__n"></span></a>';
      var btn = wrap.firstChild, lab = btn.firstChild, num = btn.lastChild, loading = false;
      btn.setAttribute('href', next);
      var paint = function () {
        num.textContent = total ? shown + ' / ' + total : '';
        btn.setAttribute('aria-label', 'Show more pieces' + (total ? ' (' + shown + ' of ' + total + ' shown)' : ''));
      };
      paint();
      pag.parentNode.insertBefore(wrap, pag.nextSibling);
      pag.classList.add('brn-pag-hidden');

      btn.addEventListener('click', function (ev) {
        if (ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
        ev.preventDefault();
        if (loading) return;
        loading = true;
        var url = next;
        btn.setAttribute('aria-busy', 'true');
        lab.textContent = 'Loading…';
        num.textContent = '';
        fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var pag2 = doc.querySelector('.pagination');
            var cards = cardsOf(findGrid(pag2, doc));
            if (!cards.length) throw new Error('no cards');
            var g = liveGrid();
            var have = {}, cur = allCards(g), ref = cur[0] || null;
            cur.forEach(function (c) { var k = keyOf(c); if (k) have[k] = 1; });
            var refImg = ref && ref.querySelector('img'), rw = refImg ? Math.round(refImg.getBoundingClientRect().width) : 0;
            var added = [];
            cards.forEach(function (c) {
              var k = keyOf(c);
              if (k && have[k]) return;
              if (k) have[k] = 1;
              var n = d.importNode(c, true);
              Array.prototype.forEach.call(n.querySelectorAll('noscript'), function (x) { x.parentNode.removeChild(x); });
              Array.prototype.forEach.call(n.querySelectorAll('img'), function (img) {
                var ds = img.getAttribute('data-src'), dss = img.getAttribute('data-srcset');
                if (ds) img.setAttribute('src', ds.replace(/\{width\}/g, '720'));
                if (dss) img.setAttribute('srcset', dss.replace(/\{width\}/g, '720'));
                if ((ds || dss) && rw && !img.getAttribute('sizes')) img.setAttribute('sizes', rw + 'px');
                if ((ds || dss) && window.lazySizes && !img.classList.contains('lazyload')) img.classList.add('lazyload');
              });
              Array.prototype.forEach.call(n.querySelectorAll('source[data-srcset]'), function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); });
              placeCard(g, n);
              added.push(n);
              extra.push(n);
            });
            reveal(added, ref);
            wireCards(added);
            shown = Math.min((start - 1) * PER + allCards(g).length, total || Infinity);
            next = nextHref(pag2, url);
            try { var u = new URL(url); history.replaceState(history.state, '', u.pathname + u.search + location.hash); } catch (e) {}
            if (!next || (total && shown >= total)) wrap.hidden = true;
            else btn.setAttribute('href', next);
            d.dispatchEvent(new CustomEvent('brnew:cards-added', { detail: { cards: added, page: pageOf(url), url: url } }));
          })
          .catch(function () { location.href = url; })
          .then(function () { loading = false; btn.removeAttribute('aria-busy'); lab.textContent = 'More'; paint(); });
      });
    } catch (e) {}
  }

  function boot() {
    try { brNewSort(); } catch (e) {}
    try { brNewUtil(0); } catch (e) {}
    try { brNewHeader(); } catch (e) {}
    try { brNewMore(); } catch (e) {}
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.BRNew = { topline: BRN_TOPLINE };
})();
/* ===== END BR LIST1 26 SEP ===== */

/* ===== BR NEWSLETTER POPUP 26 SEP =====
   Newsletter sign-up sheet, option C "bottom sheet" (approved by Vikas 26 Sep 2026, with his new text).
   Phone: a sheet slides up from the bottom of the screen. Desktop: the same sheet as a card, bottom-left.
   When: at 40% scroll on collection and product pages only (never the homepage, cart, checkout, account).
   Hidden for 3 days after a close (x, Esc, swipe down, No thanks); never again after a sign-up.
   Waits while the menu, the cart drawer, the "Good to know" sheet (#br-sheet), the size picker,
   the sale popup (.br-pop), the cookie banner or another app popup is open.
   Sign-ups post to Shopify's own customer list (form_type=customer, tags newsletter,popup-c), through
   Shopify's spam protection (hCaptcha), then the page reloads with ?customer_posted=true and this code
   shows the thank-you sheet.
   Storage (localStorage, all in try/catch): brnl_seen, brnl_closed_until, brnl_joined, brnl_pending.
   QA on the live site (browser console): BRNewsletter.show()  BRNewsletter.show('success')
   BRNewsletter.hide()  BRNewsletter.reset()  (clears the brnl_* keys so it can show again). */
(function () {
  'use strict';
  try {
    var W = window, D = document;
    if (W.__brnlLoaded) return;
    W.__brnlLoaded = true;

    /* ---------- copy (edit here) ---------- */
    var HEADING = 'Stay in the loop'; /* the sheet heading. For all caps use 'STAY IN THE LOOP'. */
    var COPY = {
      mark: 'Bhavya Ramesh',
      body: 'New launches, collections and updates, straight to your inbox.',
      button: 'SUBSCRIBE',
      placeholder: 'Email address',
      no: 'No thanks',
      fine: 'Unsubscribe anytime.',
      privacy: 'Privacy policy',
      privacyUrl: '/policies/privacy-policy',
      thanksH: 'Thank you — you’re on the list.',
      thanksP: 'You’ll hear about new launches and collections first.',
      close: 'Close',
      invalid: 'Please enter a valid email address.',
      sending: 'Sending…'
    };
    var TAGS = 'newsletter,popup-c';   /* customer tags Shopify saves with the sign-up */
    var SCROLL_AT = 0.4;               /* show at 40% of the page */
    var SNOOZE_DAYS = 3;               /* hidden this long after a close */
    var HASH = '#brnl';                /* comes back in the URL after Shopify's redirect */
    var DAY = 864e5;
    var KEY = { seen: 'brnl_seen', closed: 'brnl_closed_until', joined: 'brnl_joined', pending: 'brnl_pending' };

    function reduced() { try { return W.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
    function phone() { return W.innerWidth < 768; }
    function sget(k) { try { return W.localStorage.getItem(k); } catch (e) { return null; } }
    function sset(k, v) { try { W.localStorage.setItem(k, v); } catch (e) {} }
    function sdel(k) { try { W.localStorage.removeItem(k); } catch (e) {} }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    /* ---------- markup ---------- */
    function markup() {
      var X = '<button type="button" class="brnl-x" data-brnl-close aria-label="Close"><svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11"/></svg></button>';
      var mark = '<p class="brnl-mark">' + esc(COPY.mark) + '</p>';
      var fine = '<p class="brnl-fine">' + esc(COPY.fine) + ' <a href="' + esc(COPY.privacyUrl) + '">' + esc(COPY.privacy) + '</a></p>';
      var form = '<form class="brnl-form" method="post" action="/contact' + HASH + '" accept-charset="UTF-8" novalidate>' +
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="' + esc(TAGS) + '">' +
        '<label class="brnl-sr" for="brnl-email">' + esc(COPY.placeholder) + '</label>' +
        '<div class="brnl-field">' +
          '<input class="brnl-input" id="brnl-email" type="email" name="contact[email]" required autocomplete="email" inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="' + esc(COPY.placeholder) + '" aria-describedby="brnl-err">' +
          '<button type="submit" class="brnl-btn">' + esc(COPY.button) + '</button>' +
        '</div>' +
        '<p class="brnl-err" id="brnl-err" role="alert"></p>' +
        '</form>';
      return '<div class="brnl-card" role="dialog" aria-modal="false" aria-labelledby="brnl-h" tabindex="-1">' + X +
        '<span class="brnl-handle" aria-hidden="true"></span>' +
        '<div class="brnl-view" data-view="form">' + mark +
          '<h2 class="brnl-h" id="brnl-h">' + esc(HEADING) + '</h2>' +
          '<p class="brnl-p">' + esc(COPY.body) + '</p>' + form +
          '<div class="brnl-row"><button type="button" class="brnl-no" data-brnl-close>' + esc(COPY.no) + '</button>' + fine + '</div>' +
        '</div>' +
        '<div class="brnl-view" data-view="success">' + mark +
          '<h2 class="brnl-h" id="brnl-hs" tabindex="-1">' + esc(COPY.thanksH) + '</h2>' +
          '<p class="brnl-p">' + esc(COPY.thanksP) + '</p>' +
          '<button type="button" class="brnl-btn brnl-btn--ghost" data-brnl-close>' + esc(COPY.close) + '</button>' +
        '</div></div>';
    }

    var root = null, el = null, isOpen = false, wasAuto = false, watch = null;
    function build() {
      if (el) return el;
      root = D.getElementById('brnl-root');
      if (!root) { root = D.createElement('div'); root.id = 'brnl-root'; D.body.appendChild(root); }
      el = D.createElement('div');
      el.id = 'brnl-sheet';
      el.className = 'brnl';
      el.setAttribute('data-state', 'form');
      el.innerHTML = markup();
      root.appendChild(el);
      bind();
      return el;
    }
    function card() { return el.querySelector('.brnl-card'); }
    function setState(s) {
      el.setAttribute('data-state', s === 'success' ? 'success' : 'form');
      card().setAttribute('aria-labelledby', s === 'success' ? 'brnl-hs' : 'brnl-h');
    }

    /* ---------- show / hide ---------- */
    function shown(n) {
      if (!n) return false;
      var r = n.getBoundingClientRect(), cs = getComputedStyle(n);
      return r.width > 0 && r.height > 0 && r.right > 0 && r.bottom > 0 && r.left < W.innerWidth && r.top < W.innerHeight &&
        cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
    }
    function lift() {
      /* desktop: keep the card above a cookie banner or a sticky bar parked at the bottom */
      if (!root) return;
      var px = 0, list = [D.getElementById('shopify-pc__banner'), D.getElementById('br-buybar')], i, r;
      for (i = 0; i < list.length; i++) {
        if (!shown(list[i])) continue;
        r = list[i].getBoundingClientRect();
        if (r.bottom >= W.innerHeight - 4 && r.top > W.innerHeight * 0.4) px = Math.max(px, W.innerHeight - r.top);
      }
      root.style.setProperty('--brnl-lift', Math.round(px) + 'px');
    }
    function open(auto, instant) {
      build();
      isOpen = true; wasAuto = !!auto;
      lift();
      el.classList.toggle('brnl-instant', !!instant);
      el.classList.add('is-open');
      D.documentElement.classList.add('brnl-open');
      void el.offsetWidth;
      var go = function () { el.classList.add('is-in'); };
      if (instant || reduced()) go(); else W.requestAnimationFrame(function () { W.requestAnimationFrame(go); });
      if (watch) clearInterval(watch);
      watch = setInterval(function () {
        /* the menu, the cart drawer or another sheet opened on top: step aside, allow a later page to show it again */
        if (!isOpen) { clearInterval(watch); watch = null; return; }
        if (blocked()) { sdel(KEY.seen); close(true); }
      }, 500);
    }
    function close(silent) {
      if (!el || !isOpen) return;
      isOpen = false;
      if (!silent && wasAuto && el.getAttribute('data-state') !== 'success') sset(KEY.closed, String(Date.now() + SNOOZE_DAYS * DAY));
      el.classList.remove('is-in', 'brnl-instant');
      D.documentElement.classList.remove('brnl-open');
      if (watch) { clearInterval(watch); watch = null; }
      setTimeout(function () {
        if (!el.classList.contains('is-in')) { el.classList.remove('is-open'); var c = card(); if (c) c.style.transform = ''; }
      }, reduced() ? 0 : 360);
    }

    /* ---------- sign-up ---------- */
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function onSubmit(e) {
      /* capture phase: runs before Shopify's spam-protection handler on the form. A bad address never leaves the page;
         a good one is posted the normal way (Shopify adds its hCaptcha token, then the page reloads with customer_posted=true). */
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('brnl-form')) return;
      var inp = f.querySelector('input[type="email"]'), err = f.querySelector('.brnl-err'), btn = f.querySelector('[type="submit"]');
      var v = (inp.value || '').trim();
      if (!EMAIL.test(v)) {
        e.preventDefault(); e.stopPropagation();
        err.textContent = COPY.invalid; err.classList.add('is-on');
        inp.setAttribute('aria-invalid', 'true');
        try { inp.focus(); } catch (x) {}
        return;
      }
      inp.value = v;
      err.classList.remove('is-on'); inp.removeAttribute('aria-invalid');
      sset(KEY.pending, String(Date.now()));
      sset(KEY.seen, String(Date.now()));
      if (btn && !btn.disabled) {
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = COPY.sending;
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 12000);
      }
    }
    function thanks(instant) {
      build();
      setState('success');
      open(false, instant);
      var h = el.querySelector('#brnl-hs');
      if (h && !phone()) { try { h.focus({ preventScroll: true }); } catch (x) {} }
    }

    /* ---------- events ---------- */
    function bind() {
      root.addEventListener('click', function (e) {
        var t = e.target;
        var cl = t.closest && t.closest('[data-brnl-close]');
        if (cl) { e.preventDefault(); close(false); }
      });
      root.addEventListener('submit', onSubmit, true);
      D.addEventListener('keydown', function (e) {
        if (isOpen && (e.key === 'Escape' || e.key === 'Esc')) close(false);
      });
      W.addEventListener('resize', lift);
      /* phone: drag the top of the sheet down to dismiss */
      var c = card(), y0 = null, dy = 0;
      c.addEventListener('touchstart', function (e) {
        if (!phone() || e.touches.length !== 1) return;
        if (e.touches[0].clientY - c.getBoundingClientRect().top > 64) return;
        y0 = e.touches[0].clientY; dy = 0; c.classList.add('is-dragging');
      }, { passive: true });
      c.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        c.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      c.addEventListener('touchend', function () {
        if (y0 === null) return;
        y0 = null; c.classList.remove('is-dragging');
        if (dy > 80) close(false); else c.style.transform = '';
      });
    }

    /* ---------- when to show ---------- */
    function blocked() {
      var b = D.body, h = D.documentElement;
      if (!b) return true;
      if (b.classList.contains('navigation-open') || b.classList.contains('drawer--active')) return true;
      var sel = ['#br-sheet.is-on', '#br-pick.is-on', '#br-pop', '#shopify-pc__banner', '.popup-country', '[aria-modal="true"]'];
      for (var i = 0; i < sel.length; i++) {
        var ns = D.querySelectorAll(sel[i]);
        for (var j = 0; j < ns.length; j++) if (!(root && root.contains(ns[j])) && shown(ns[j])) return true;
      }
      return false;
    }
    function busy() {
      var a = D.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !(root && root.contains(a))) return true;
      return blocked();
    }
    function scrollPct() {
      var h = Math.max(D.documentElement.scrollHeight, D.body.scrollHeight) - W.innerHeight;
      return h > 0 ? (W.pageYOffset || D.documentElement.scrollTop) / h : 0;
    }
    var fired = false, waiting = null;
    function fire() {
      if (fired) return;
      if (sget(KEY.joined)) return;
      if (busy()) {
        if (!waiting) {
          var tries = 0;
          waiting = setInterval(function () {
            tries++;
            if (!busy()) { clearInterval(waiting); waiting = null; setTimeout(fire, 1500); }
            else if (tries > 90) { clearInterval(waiting); waiting = null; }
          }, 2000);
        }
        return;
      }
      fired = true;
      build();
      setState('form');
      open(true, false);
      sset(KEY.seen, String(Date.now()));
    }
    function cleanUrl() {
      try {
        var u = new URL(location.href);
        u.searchParams.delete('customer_posted');
        history.replaceState(history.state, '', u.pathname + (u.search || ''));
      } catch (e) {}
    }

    function init() {
      var now = Date.now(), q = location.search || '', path = location.pathname || '/';
      if (/[?&]customer_posted=true/.test(q)) {
        /* back from Shopify after a sign-up. Ours (the sheet was pending) -> thank-you sheet; the footer form -> just remember it */
        var pend = +sget(KEY.pending) || 0;
        sset(KEY.joined, String(now));
        sdel(KEY.pending);
        if (now - pend < 30 * 60 * 1000) {
          cleanUrl();
          setTimeout(function () { thanks(false); }, 500);
        }
        return;
      }
      if (+sget(KEY.pending) && now - (+sget(KEY.pending)) > 30 * 60 * 1000) sdel(KEY.pending);
      if (/[?&]utm_medium=email\b/i.test(q)) sset(KEY.joined, 'email');
      if (sget(KEY.joined)) return;
      if (D.body && D.body.classList.contains('customer-logged-in')) return;
      if (!/\/(collections|products)\//.test(path)) return;
      if (/\/(cart|checkouts?|account|challenge|password)(\/|$)/i.test(path)) return;
      if (now < (+sget(KEY.closed) || 0)) return;
      var seen = +sget(KEY.seen) || 0;
      if (seen && now - seen < SNOOZE_DAYS * DAY) return;
      var onScroll = function () {
        if (scrollPct() >= SCROLL_AT) { W.removeEventListener('scroll', onScroll); fire(); }
      };
      W.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---------- public (QA) ---------- */
    W.BRNewsletter = {
      show: function (state) {
        try {
          build();
          if (isOpen) close(true);
          el.classList.remove('is-in', 'is-open');
          if (state === 'success') thanks(false); else { setState('form'); open(false, false); }
          return true;
        } catch (e) { return false; }
      },
      hide: function () { close(true); },
      reset: function () { for (var k in KEY) sdel(KEY[k]); return 'brnl_* cleared'; },
      heading: HEADING
    };

    function boot() { try { init(); } catch (e) {} }
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  } catch (e) {}
})();
/* ===== END BR NEWSLETTER POPUP 26 SEP ===== */

/* ===== BR PDP-TEXT 26 SEP =====
   Good to know pop-ups on the product page (Certificate, Handmade in Jaipur, Product FAQs).
   Companion of the BR PDP-TEXT block in br-bw.css and the edits in sections/product-template.liquid.
   Does nothing on pages without #br-sheet / .brfaq-own. Never throws. */
(function () {
  var d = document;
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* 1 - The product's own FAQ metafield ("Question: ... Answer: ..." in one rich-text block) becomes the same
        + / - rows as the 11 shared questions above it. If the text is not in that form it is left exactly as it is. */
  function brFaqOwn() {
    var box = d.querySelector('.brfaq-own');
    if (!box || box.querySelector('.brfaq-i')) return;
    var c = box.cloneNode(true);
    c.innerHTML = c.innerHTML.replace(/<br\s*\/?>/gi, '\n');
    var text = (c.textContent || '').replace(/\u00a0/g, ' ');
    var parts = text.split(/(?:^|\s)(?:Question|QUESTION)\s*\d*\s*[:\-\u2013]\s*/).slice(1), html = '';
    for (var i = 0; i < parts.length; i++) {
      var m = parts[i].split(/(?:^|\s)(?:Answer|ANSWER)\s*\d*\s*[:\-\u2013]\s*/);
      if (m.length < 2) continue;
      var q = m[0].replace(/\s+/g, ' ').trim(), a = m.slice(1).join(' ').replace(/\s+/g, ' ').trim();
      if (!q || !a) continue;
      html += '<details class="brfaq-i" name="brfaq"><summary class="brfaq-q"><span>' + esc(q) + '</span><i class="brfaq-ic" aria-hidden="true"></i></summary>' +
              '<div class="brfaq-a"><p>' + esc(a) + '</p></div></details>';
    }
    if (html) { box.innerHTML = html; box.classList.add('brfaq-list'); }
  }

  /* 2 - One row open at a time. Modern browsers do this through details name="brfaq";
        older ones (Chrome < 120, Safari < 17.2, Firefox < 130) get this small fallback. */
  function brFaqOne() {
    var native = false;
    try { native = ('name' in HTMLDetailsElement.prototype); } catch (e) { native = false; }
    if (native) return;
    d.addEventListener('toggle', function (e) {
      var t = e.target;
      if (!t || !t.open || !t.classList || !t.classList.contains('brfaq-i')) return;
      var all = d.querySelectorAll('.brfaq-i[open]');
      for (var i = 0; i < all.length; i++) if (all[i] !== t) all[i].open = false;
    }, true);
  }

  /* 3 - Shared pop-up frame (#br-sheet, built by brTrust): title + close cross pinned while the pop-up scrolls,
        the pop-up starts at the top each time it opens, and the floating chat / currency / language buttons
        step aside while it is open (html.brfaq-open). */
  function brSheet() {
    var sh = d.getElementById('br-sheet'); if (!sh) return;
    var bx = sh.querySelector('.box');
    if (bx && !bx.querySelector('.brfaq-hd')) {
      var h3 = bx.querySelector('h3'), x = bx.querySelector('.x');
      if (h3) {
        var hd = d.createElement('div'); hd.className = 'brfaq-hd';
        bx.insertBefore(hd, h3); hd.appendChild(h3); if (x) hd.appendChild(x);
        bx.classList.add('brfaq-pin');
      }
    }
    var sync = function () {
      var on = sh.classList.contains('is-on');
      d.documentElement.classList.toggle('brfaq-open', on);
      if (on && bx) bx.scrollTop = 0;
    };
    if (window.MutationObserver) new MutationObserver(sync).observe(sh, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function boot() {
    try { brFaqOwn(); } catch (e) {}
    try { brFaqOne(); } catch (e) {}
    try { brSheet(); } catch (e) {}
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* ===== END BR PDP-TEXT 26 SEP ===== */

/* ===== BR ETA 26 SEP =====
   Delivery-date timeline under Add to cart on product pages. Vikas, list 2 point 2, option D
   "A small timeline under Add to Cart" ("This option", 26 Sep 2026, from the 22 Sep PDF).
   What it draws, under #br-pdp-atc (the visible Add to cart button in snippets/br-pdp.liquid):
     "Delivering to <place> v"  - opens a country + pin-code chooser (India: 6-digit pin code);
                                  the choice is remembered in this browser (localStorage "breta").
     three circles              - Order today / Dispatched / Arrives, each with its date; the last one solid white.
     "Handmade to order in Jaipur · Free delivery"  - or the delivery charge for that country and this price.
   The dates copy Shopify checkout's own rule (help.shopify.com > manual delivery dates): working days are
   Monday to Friday minus the HOLIDAYS list; cut-off CUTOFF_HOUR India time; MAKING_DAYS working days to make;
   then the courier's working days (TRANSIT). All on India calendar dates, so every visitor sees the same date.
   Does nothing on pages without .br-pdp__main. Only global: window.BREta (also globalThis.BREta in Node, for tests).
   To switch off: delete this block (and the BR ETA block in br-bw.css). */
(function (root) {
  'use strict';

  /* ================= THE NUMBERS - change here only ================= */
  var MAKING_DAYS = 5;                         /* working days to make, check and hand to the courier. Shopify checkout uses 5 too. 6 = one day of buffer. */
  var CUTOFF_HOUR = 12;                        /* India time, 24-hour clock. Before this on a working day, today is making day 1; otherwise the next working day is. Shopify's fixed cut-off. */
  var TRANSIT = { IN: [2, 3], '*': [6, 9] };   /* courier working days after dispatch: India prepaid 2-3, every other country (US included) 6-9 */
  var HOLIDAYS = ['2026-10-02', '2026-10-20', '2026-11-09', '2026-11-11', '2026-11-24', '2026-12-25', '2027-01-26'];
  /* ^ workshop closed, India dates YYYY-MM-DD (Gandhi Jayanti, Dussehra, Govardhan Puja, Bhai Dooj, Guru Nanak Jayanti, Christmas, Republic Day).
       Weekends are skipped anyway. Set [] to match checkout exactly (checkout knows no holidays). */
  var HOLIDAYS_IN_TRANSIT = false;             /* true also skips HOLIDAYS in India courier days (checkout does not) */
  var FEE = { inFreeFrom: 1500, inBelow: 150, us: 2000, intl: 1500, intlAbove: 1800, intlFrom: 14000 };
  /* ^ rupees, the bands in Settings > Shipping: India free from 1,500 (150 below); United States 2,000; other countries 1,500, 1,800 above 14,000 */
  var RUPEE = 'Rs. ';                        /* rupee sign, as in the site's own shipping copy. Set 'Rs ' to match the 22 Sep picture exactly ("Delivery Rs 2,000"). */
  var DEFAULT_COUNTRY = 'auto';                /* 'auto' = the country behind the currency the BUCKS app auto-picked for the visitor (USD = US, GBP = GB ...), India when unknown. Shopify.country is NOT used: it says AE for Indian visitors on this store. 'IN' = always start with India */
  var FEE_IN_FOREIGN_CURRENCY = true;          /* when the currency app shows another currency: true = still say "Delivery ₹2,000" (checkout charges rupees); false = only "Handmade to order in Jaipur" */
  var STORE_KEY = 'breta';                     /* localStorage key for the visitor's choice {c:"IN", p:"400001"} */
  var TEXT = { to: 'Delivering to', order: 'Order today', dispatch: 'Dispatched', arrive: 'Arrives',
    foot: 'Handmade to order in Jaipur', free: 'Free delivery', fee: 'Delivery ', update: 'Update', pin: 'Pin code', country: 'Country' };
  /* ================================================================== */

  /* ---------- countries Shopify sells to (localization.available_countries on 22 Sep 2026, Pakistan removed as a market). India first, then the biggest markets, then A-Z ---------- */
  var COUNTRIES = 'IN:India|US:United States|CA:Canada|GB:United Kingdom|AU:Australia|AE:United Arab Emirates|AF:Afghanistan|AX:\u00C5land Islands|AL:Albania|DZ:Algeria|AD:Andorra|AO:Angola|AI:Anguilla|AG:Antigua & Barbuda|AR:Argentina|AM:Armenia|AW:Aruba|AC:Ascension Island|AT:Austria|AZ:Azerbaijan|BS:Bahamas|BH:Bahrain|BD:Bangladesh|BB:Barbados|BY:Belarus|BE:Belgium|BZ:Belize|BJ:Benin|BM:Bermuda|BT:Bhutan|BO:Bolivia|BA:Bosnia & Herzegovina|BW:Botswana|BR:Brazil|IO:British Indian Ocean Territory|VG:British Virgin Islands|BN:Brunei|BG:Bulgaria|BF:Burkina Faso|BI:Burundi|KH:Cambodia|CM:Cameroon|CV:Cape Verde|BQ:Caribbean Netherlands|KY:Cayman Islands|CF:Central African Republic|TD:Chad|CL:Chile|CN:China|CX:Christmas Island|CC:Cocos (Keeling) Islands|CO:Colombia|KM:Comoros|CG:Congo - Brazzaville|CD:Congo - Kinshasa|CK:Cook Islands|CR:Costa Rica|CI:C\u00F4te d\u2019Ivoire|HR:Croatia|CW:Cura\u00E7ao|CY:Cyprus|CZ:Czechia|DK:Denmark|DJ:Djibouti|DM:Dominica|DO:Dominican Republic|EC:Ecuador|EG:Egypt|SV:El Salvador|GQ:Equatorial Guinea|ER:Eritrea|EE:Estonia|SZ:Eswatini|ET:Ethiopia|FK:Falkland Islands|FO:Faroe Islands|FJ:Fiji|FI:Finland|FR:France|GF:French Guiana|PF:French Polynesia|TF:French Southern Territories|GA:Gabon|GM:Gambia|GE:Georgia|DE:Germany|GH:Ghana|GI:Gibraltar|GR:Greece|GL:Greenland|GD:Grenada|GP:Guadeloupe|GT:Guatemala|GG:Guernsey|GN:Guinea|GW:Guinea-Bissau|GY:Guyana|HT:Haiti|HN:Honduras|HK:Hong Kong SAR|HU:Hungary|IS:Iceland|ID:Indonesia|IQ:Iraq|IE:Ireland|IM:Isle of Man|IL:Israel|IT:Italy|JM:Jamaica|JP:Japan|JE:Jersey|JO:Jordan|KZ:Kazakhstan|KE:Kenya|KI:Kiribati|XK:Kosovo|KW:Kuwait|KG:Kyrgyzstan|LA:Laos|LV:Latvia|LB:Lebanon|LS:Lesotho|LR:Liberia|LY:Libya|LI:Liechtenstein|LT:Lithuania|LU:Luxembourg|MO:Macao SAR|MG:Madagascar|MW:Malawi|MY:Malaysia|MV:Maldives|ML:Mali|MT:Malta|MQ:Martinique|MR:Mauritania|MU:Mauritius|YT:Mayotte|MX:Mexico|MD:Moldova|MC:Monaco|MN:Mongolia|ME:Montenegro|MS:Montserrat|MA:Morocco|MZ:Mozambique|MM:Myanmar (Burma)|NA:Namibia|NR:Nauru|NP:Nepal|NL:Netherlands|NC:New Caledonia|NZ:New Zealand|NI:Nicaragua|NE:Niger|NG:Nigeria|NU:Niue|NF:Norfolk Island|MK:North Macedonia|NO:Norway|OM:Oman|PS:Palestinian Territories|PA:Panama|PG:Papua New Guinea|PY:Paraguay|PE:Peru|PH:Philippines|PN:Pitcairn|PL:Poland|PT:Portugal|QA:Qatar|RE:R\u00E9union|RO:Romania|RU:Russia|RW:Rwanda|WS:Samoa|SM:San Marino|ST:Sao Tome & Principe|SA:Saudi Arabia|SN:Senegal|RS:Serbia|SC:Seychelles|SL:Sierra Leone|SG:Singapore|SX:Sint Maarten|SK:Slovakia|SI:Slovenia|SB:Solomon Islands|SO:Somalia|ZA:South Africa|GS:South Georgia & South Sandwich Islands|KR:South Korea|SS:South Sudan|ES:Spain|LK:Sri Lanka|BL:St. Barth\u00E9lemy|SH:St. Helena|KN:St. Kitts & Nevis|LC:St. Lucia|MF:St. Martin|PM:St. Pierre & Miquelon|VC:St. Vincent & Grenadines|SD:Sudan|SR:Suriname|SJ:Svalbard & Jan Mayen|SE:Sweden|CH:Switzerland|TW:Taiwan|TJ:Tajikistan|TZ:Tanzania|TH:Thailand|TL:Timor-Leste|TG:Togo|TK:Tokelau|TO:Tonga|TT:Trinidad & Tobago|TA:Tristan da Cunha|TN:Tunisia|TR:T\u00FCrkiye|TM:Turkmenistan|TC:Turks & Caicos Islands|TV:Tuvalu|UM:U.S. Outlying Islands|UG:Uganda|UA:Ukraine|UY:Uruguay|UZ:Uzbekistan|VU:Vanuatu|VA:Vatican City|VE:Venezuela|VN:Vietnam|WF:Wallis & Futuna|EH:Western Sahara|YE:Yemen|ZM:Zambia|ZW:Zimbabwe';

  /* ---------- date maths (same as the 22 Sep preview's br-eta.js) ---------- */
  var DAY = 86400000, IST = 330;
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function istParts(d) { var t = new Date(d.getTime() + IST * 60000); return { y: t.getUTCFullYear(), m: t.getUTCMonth(), d: t.getUTCDate(), h: t.getUTCHours() }; }
  function ymd(day) { return new Date(day).toISOString().slice(0, 10); }
  function isWorking(day, useHol) { var wd = new Date(day).getUTCDay(); if (wd === 0 || wd === 6) return false; return !(useHol && HOLIDAYS.indexOf(ymd(day)) > -1); }
  function addWorking(day, n, useHol) { while (n > 0) { day += DAY; if (isWorking(day, useHol)) n--; } return day; }
  function fmt(day, withMonth) { var t = new Date(day); return WD[t.getUTCDay()] + ' ' + t.getUTCDate() + (withMonth === false ? '' : ' ' + MO[t.getUTCMonth()]); }
  function fmtRange(a, b) { if (a === b) return fmt(a); var same = new Date(a).getUTCMonth() === new Date(b).getUTCMonth(); return fmt(a, !same) + ' \u2013 ' + fmt(b); }
  /* estimate('US', new Date()) -> { orderDay, dispatch, from, to (YYYY-MM-DD), beforeCutoff, text:{ordered, dispatch, range} } */
  function estimate(country, now) {
    var p = istParts(now || new Date());
    var orderDay = Date.UTC(p.y, p.m, p.d);
    var before = p.h < CUTOFF_HOUR && isWorking(orderDay, true);
    var dispatch = addWorking(orderDay, MAKING_DAYS + (before ? 0 : 1), true);
    var tr = TRANSIT[country] || TRANSIT['*'];
    var hol = HOLIDAYS_IN_TRANSIT && country === 'IN';
    var from = addWorking(dispatch, tr[0], hol), to = addWorking(dispatch, tr[1], hol);
    return { country: country, orderDay: ymd(orderDay), dispatch: ymd(dispatch), from: ymd(from), to: ymd(to), beforeCutoff: before,
      text: { ordered: fmt(orderDay), dispatch: fmt(dispatch), range: fmtRange(from, to) } };
  }
  /* delivery charge in rupees for this country and this piece's rupee price; 0 = free */
  function fee(country, inr) {
    if (country === 'IN') return inr >= FEE.inFreeFrom ? 0 : FEE.inBelow;
    if (country === 'US') return FEE.us;
    return inr > FEE.intlFrom ? FEE.intlAbove : FEE.intl;
  }
  function rupees(n) { return RUPEE + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* ---------- pin codes: 6 digits, first 1-8; big cities named by the first 3 digits, states by the first 2 ---------- */
  var METRO = { '110': 'Delhi', '400': 'Mumbai', '411': 'Pune', '560': 'Bengaluru', '600': 'Chennai', '700': 'Kolkata', '500': 'Hyderabad',
    '380': 'Ahmedabad', '302': 'Jaipur', '122': 'Gurugram', '160': 'Chandigarh', '226': 'Lucknow', '403': 'Goa', '682': 'Kochi', '452': 'Indore',
    '395': 'Surat', '440': 'Nagpur', '641': 'Coimbatore', '737': 'Sikkim', '605': 'Puducherry' };
  var STATE = { '11': 'Delhi', '12': 'Haryana', '13': 'Haryana', '14': 'Punjab', '15': 'Punjab', '17': 'Himachal Pradesh', '18': 'Jammu & Kashmir',
    '30': 'Rajasthan', '31': 'Rajasthan', '32': 'Rajasthan', '33': 'Rajasthan', '34': 'Rajasthan', '36': 'Gujarat', '37': 'Gujarat', '38': 'Gujarat',
    '39': 'Gujarat', '40': 'Maharashtra', '41': 'Maharashtra', '42': 'Maharashtra', '43': 'Maharashtra', '44': 'Maharashtra', '45': 'Madhya Pradesh',
    '46': 'Madhya Pradesh', '47': 'Madhya Pradesh', '48': 'Madhya Pradesh', '49': 'Chhattisgarh', '56': 'Karnataka', '57': 'Karnataka', '58': 'Karnataka',
    '59': 'Karnataka', '60': 'Tamil Nadu', '61': 'Tamil Nadu', '62': 'Tamil Nadu', '63': 'Tamil Nadu', '64': 'Tamil Nadu', '67': 'Kerala', '68': 'Kerala',
    '69': 'Kerala', '70': 'West Bengal', '71': 'West Bengal', '72': 'West Bengal', '73': 'West Bengal', '75': 'Odisha', '76': 'Odisha', '77': 'Odisha', '78': 'Assam' };
  function checkPin(raw) {
    var pin = String(raw || '').replace(/\s+/g, '');
    if (!pin) return { ok: false, msg: 'Enter your 6-digit pin code' };
    if (!/^\d+$/.test(pin)) return { ok: false, msg: 'Pin codes have numbers only' };
    if (pin.length !== 6) return { ok: false, msg: 'Pin codes have 6 digits' };
    if (!/^[1-8]/.test(pin)) return { ok: false, msg: 'Please check the pin code' };
    var place = METRO[pin.slice(0, 3)] || STATE[pin.slice(0, 2)] || '';
    return { ok: true, pin: pin, place: place, label: (place ? place + ' ' : '') + pin };
  }

  var LIST = COUNTRIES.split('|').map(function (x) { var i = x.indexOf(':'); return { code: x.slice(0, i), name: x.slice(i + 1) }; });
  function countryName(code) { for (var i = 0; i < LIST.length; i++) if (LIST[i].code === code) return LIST[i].name; return ''; }
  /* what the chip says: "Mumbai 400001", "India", "United States" */
  function label(state) { if (state.c === 'IN' && state.p) { var r = checkPin(state.p); if (r.ok) return r.label; } return countryName(state.c) || state.c; }
  function footText(state, inr, showFee) {
    var s = TEXT.foot;
    if (showFee && inr > 0) { var f = fee(state.c, inr); s += ' \u00B7 ' + (f === 0 ? TEXT.free : TEXT.fee + rupees(f)); }
    return s;
  }

  var api = { estimate: estimate, fee: fee, checkPin: checkPin, label: label, footText: footText, countries: LIST,
    config: { makingDays: MAKING_DAYS, cutoffHour: CUTOFF_HOUR, transit: TRANSIT, holidays: HOLIDAYS } };
  root.BREta = api;
  if (typeof document === 'undefined') return;   /* Node: maths only */

  /* ---------- the page ---------- */
  var d = document;
  var ICON = {
    bag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l1 12H5L6 8zm3 0V6a3 3 0 0 1 6 0v2"/></svg>',
    make: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5c3 3.3 4.8 6 4.8 8.6a4.8 4.8 0 0 1-9.6 0c0-2.6 1.8-5.3 4.8-8.6z"/><path d="M12 20.5v-3.6"/></svg>',
    home: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10.8 12 4l8 6.8V20h-5.2v-5.6H9.2V20H4z"/></svg>',
    down: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  };
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { s = null; }
    if (s && countryName(s.c)) return { c: s.c, p: (s.c === 'IN' && checkPin(s.p).ok) ? checkPin(s.p).pin : '' };
    var c = 'IN';
    if (DEFAULT_COUNTRY === 'auto') { var cc = { USD: 'US', CAD: 'CA', GBP: 'GB', AUD: 'AU', AED: 'AE', SGD: 'SG', EUR: 'DE', NZD: 'NZ', HKD: 'HK', JPY: 'JP', SAR: 'SA', QAR: 'QA', INR: 'IN' }[currency()]; if (cc && countryName(cc)) c = cc; }
    else if (countryName(DEFAULT_COUNTRY)) c = DEFAULT_COUNTRY;
    return { c: c, p: '' };
  }
  function save(state) { try { localStorage.setItem(STORE_KEY, JSON.stringify({ c: state.c, p: state.p || '' })); } catch (e) {} }
  /* active display currency, the way the INR note detects it (BUCKS converter) */
  function currency() {
    var m = d.querySelector('.money[bucks-currency]');
    if (m && /^[A-Z]{3}$/.test(m.getAttribute('bucks-currency') || '')) return m.getAttribute('bucks-currency');
    try { var a = JSON.parse(localStorage.getItem('buckscc_last_manual') || 'null'), b = JSON.parse(localStorage.getItem('buckscc_auto_currency') || 'null'); var x = (a && b) ? (a.timestamp > b.timestamp ? a : b) : (a || b); return (x && x.currency) || 'INR'; } catch (e) { return 'INR'; }
  }
  /* this variant's price in rupees, always from the variants JSON (never from the converted price on screen) */
  function inrPrice() {
    try {
      var vs = JSON.parse(d.getElementById('br-pdp-variants').textContent);
      var sel = d.querySelector('form.product-form [name="id"]');
      var v = null;
      if (sel && sel.value) { for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(sel.value)) { v = vs[i]; break; } }
      if (!v) v = vs[0];
      return v ? v.price / 100 : 0;
    } catch (e) {}
    try {
      if (currency() !== 'INR') return 0;
      var t = (d.getElementById('br-pdp-price') || {}).textContent || '';
      var n = parseFloat(t.replace(/[^\d.]/g, ''));
      return isNaN(n) ? 0 : n;
    } catch (e2) { return 0; }
  }

  function init() {
    if (!d.querySelector('.br-pdp__main')) return;
    var atc = d.getElementById('br-pdp-atc');
    if (!atc || d.getElementById('breta')) return;
    var state = load();

    var box = d.createElement('div');
    box.className = 'breta';
    box.id = 'breta';
    box.innerHTML =
      '<div class="breta__to"><span class="breta__lbl"></span>' +
      '<button type="button" class="breta__chip" aria-expanded="false" aria-controls="breta-form"><span class="breta__place"></span>' + ICON.down + '</button></div>' +
      '<div class="breta__form" id="breta-form" hidden>' +
      '<label class="breta__sel"><select class="breta__country"></select></label>' +
      '<input class="breta__pin" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="6" pattern="[0-9]*">' +
      '<button type="button" class="breta__go"></button>' +
      '<div class="breta__err" role="status" aria-live="polite"></div></div>' +
      '<div class="breta__tl">' +
      '<div class="breta__st"><div class="breta__dot">' + ICON.bag + '</div><div class="breta__k breta__k--order"></div><div class="breta__v breta__v--order"></div></div>' +
      '<div class="breta__st"><div class="breta__dot">' + ICON.make + '</div><div class="breta__k breta__k--dispatch"></div><div class="breta__v breta__v--dispatch"></div></div>' +
      '<div class="breta__st breta__st--end"><div class="breta__dot">' + ICON.home + '</div><div class="breta__k breta__k--arrive"></div><div class="breta__v breta__v--arrive"></div></div>' +
      '</div><div class="breta__foot"></div>';
    var q = function (s) { return box.querySelector(s); };
    q('.breta__lbl').textContent = TEXT.to;
    q('.breta__k--order').textContent = TEXT.order; q('.breta__k--dispatch').textContent = TEXT.dispatch; q('.breta__k--arrive').textContent = TEXT.arrive;
    q('.breta__go').textContent = TEXT.update;
    var chip = q('.breta__chip'), form = q('.breta__form'), sel = q('.breta__country'), pin = q('.breta__pin'), go = q('.breta__go'), err = q('.breta__err');
    sel.setAttribute('aria-label', TEXT.country);
    pin.setAttribute('aria-label', TEXT.pin); pin.setAttribute('placeholder', TEXT.pin);
    for (var i = 0; i < LIST.length; i++) { var o = d.createElement('option'); o.value = LIST[i].code; o.text = LIST[i].name; sel.appendChild(o); }
    atc.parentNode.insertBefore(box, atc.nextSibling);

    var sig = '';
    function paint(force) {
      var inr = inrPrice(), cur = currency(), sold = !!atc.disabled;
      var e = estimate(state.c);
      var showFee = cur === 'INR' || FEE_IN_FOREIGN_CURRENCY;
      var s = [state.c, state.p, inr, cur, sold, e.orderDay, e.dispatch, e.from, e.to].join('|');
      if (!force && s === sig) return; sig = s;
      box.hidden = sold;                                   /* nothing to promise on a sold-out piece */
      q('.breta__place').textContent = label(state);
      sel.value = state.c;
      pin.hidden = go.hidden = state.c !== 'IN';                 /* abroad the country is enough: the select applies at once */
      if (d.activeElement !== pin) pin.value = state.p || '';
      q('.breta__v--order').textContent = e.text.ordered;
      q('.breta__v--dispatch').textContent = e.text.dispatch;
      q('.breta__v--arrive').textContent = e.text.range;
      q('.breta__foot').textContent = footText(state, inr, showFee);
    }
    function open(on) { form.hidden = !on; chip.setAttribute('aria-expanded', on ? 'true' : 'false'); if (!on) err.textContent = ''; }
    function apply(closeAfter) {
      err.textContent = '';
      if (state.c === 'IN') {
        var raw = pin.value.replace(/\s+/g, '');
        if (raw) { var r = checkPin(raw); if (!r.ok) { err.textContent = r.msg; return false; } state.p = r.pin; }
        else state.p = '';
      } else state.p = '';
      save(state); paint(true);
      if (closeAfter) open(false);
      return true;
    }
    chip.addEventListener('click', function () { open(form.hidden); if (!form.hidden && state.c === 'IN' && !state.p && window.innerWidth >= 768) pin.focus(); });
    sel.addEventListener('change', function () {
      state.c = sel.value; if (state.c !== 'IN') state.p = '';
      pin.hidden = go.hidden = state.c !== 'IN'; err.textContent = '';
      save(state); paint(true);
      if (state.c !== 'IN') open(false);                  /* abroad the country is enough: one delivery time per country */
    });
    pin.addEventListener('input', function () {
      var v = pin.value.replace(/\D/g, '').slice(0, 6);
      if (v !== pin.value) pin.value = v;
      err.textContent = '';
      if (v.length === 6 && checkPin(v).ok) { state.p = v; save(state); paint(true); }
    });
    pin.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); apply(true); } });
    go.addEventListener('click', function () { apply(true); });
    box.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !form.hidden) { open(false); chip.focus(); } });
    d.addEventListener('click', function (ev) { if (!form.hidden && !box.contains(ev.target)) open(false); });

    /* keep it right: variant change (price), currency app, sold out, and the noon cut-off */
    var priceNode = d.getElementById('br-pdp-price');
    if (priceNode && root.MutationObserver) new MutationObserver(function () { setTimeout(function () { paint(false); }, 30); }).observe(priceNode, { childList: true, characterData: true, subtree: true });
    d.addEventListener('change', function (ev) { if (ev.target && ev.target.closest && ev.target.closest('form.product-form')) setTimeout(function () { paint(false); }, 150); });
    setInterval(function () { paint(false); }, 1000);
    paint(true);
    api.paint = function () { paint(true); };   /* BREta.paint() in the console redraws; BREta.state is the current choice; BREta.inrPrice() the rupee price used */
    api.state = state;
    api.inrPrice = inrPrice;
  }
  function boot() { try { init(); } catch (e) { if (root.console && console.warn) console.warn('BR ETA', e); } }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})(typeof window !== 'undefined' ? window : globalThis);
/* ===== END BR ETA 26 SEP ===== */

/* BR GIFT, 26 Sep 2026 (option C, approved by Vikas): "This is a gift" switch in the bag, for the whole order.
   Lives under the pieces in the cart drawer (snippets/cart-drawer.liquid) and above the buttons on /cart.
   Saves cart attributes "Gift wrap" = Yes and "Gift message" (up to 160 characters) through /cart/update.js,
   reads them back from /cart.js whenever the drawer opens, and never blocks checkout: the same two values also
   travel as form fields inside the cart form, so a checkout still carries them if the ajax save failed.
   The theme's drawer re-renders itself with a DOM morph after every cart change; the block is keyed by its id
   and all its state lives in attributes, so it survives that. Everything is prefixed brgw-. */
(function () {
  'use strict';
  try {
    var d = document;
    var MAX = 160;                                   /* note length, matches the notification templates */
    var DEBOUNCE = 600;                              /* ms after the last keystroke before the note is saved */
    var CART_PAGE = true;                            /* also show the block on /cart (above the buttons) */
    var KEY_ON = 'Gift wrap', KEY_MSG = 'Gift message', YES = 'Yes';
    var TXT = {
      title: 'This is a gift',
      sub: 'Complimentary gift wrap for the whole order',
      placeholder: 'Write a short note (optional)',
      help: 'Goes on a card inside the wrap. No prices inside the parcel.',
      aria: 'Gift note, up to ' + MAX + ' characters'
    };
    var state = { on: false, msg: '' };
    var dirty = false, saving = false, timer = null, loading = false;

    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    /* where the block goes: drawer item list (before "Special request"), else the /cart buttons */
    function spot() {
      var list = d.querySelector('.drawer [data-cart-item-list]');
      if (list) return { parent: list, before: list.querySelector('[data-cart-note-container]') };
      if (!CART_PAGE || !d.body.classList.contains('template-cart')) return null;
      var btn = d.querySelector('form[action="/cart"] .cart__checkout, form[action="/cart"] [name="checkout"]');
      if (!btn) return null;
      var anc = btn.closest('.btn-group') || btn;
      return { parent: anc.parentNode, before: anc };
    }
    function isCartPage() { return d.body.classList.contains('template-cart'); }

    function build() {
      var el = d.createElement('div');
      el.id = 'brgw'; el.className = 'brgw';
      el.innerHTML =
        '<div class="brgw__row"><div class="brgw__txt"><div class="brgw__t" id="brgw-t">' + esc(TXT.title) + '</div><div class="brgw__s">' + esc(TXT.sub) + '</div></div>' +
        '<button type="button" class="brgw__sw" role="switch" aria-checked="false" aria-labelledby="brgw-t"><i></i></button></div>' +
        '<div class="brgw__more"><div class="brgw__tw">' +
        '<textarea class="brgw__ta" id="brgw-msg" name="attributes[' + KEY_MSG + ']" rows="3" maxlength="' + MAX + '" placeholder="' + esc(TXT.placeholder) + '" aria-label="' + esc(TXT.aria) + '" autocomplete="off" autocapitalize="sentences" disabled></textarea>' +
        '<i class="brgw__cnt" aria-live="polite" aria-atomic="true">0/' + MAX + '</i></div>' +
        '<div class="brgw__h">' + esc(TXT.help) + '</div></div>' +
        '<input class="brgw__flag" type="hidden" name="attributes[' + KEY_ON + ']" value="">';
      return el;
    }

    function mount() {
      if (d.getElementById('brgw')) return true;
      var s = spot(); if (!s) return false;
      s.parent.insertBefore(build(), s.before || null);
      paint();
      return true;
    }

    function paint() {
      var el = d.getElementById('brgw'); if (!el) return;
      var ta = el.querySelector('.brgw__ta'), sw = el.querySelector('.brgw__sw'), flag = el.querySelector('.brgw__flag'), cnt = el.querySelector('.brgw__cnt');
      el.classList.toggle('is-on', state.on);
      if (sw) sw.setAttribute('aria-checked', state.on ? 'true' : 'false');
      if (ta) {
        if (d.activeElement !== ta && ta.value !== state.msg) ta.value = state.msg;
        ta.disabled = !state.on;
        if (ta.disabled) ta.setAttribute('disabled', ''); else ta.removeAttribute('disabled');
      }
      if (flag) { flag.value = state.on ? YES : ''; flag.setAttribute('value', flag.value); }
      var n = state.on && ta ? ta.value.length : 0;
      if (cnt) cnt.textContent = n + '/' + MAX;
      el.classList.toggle('is-full', n >= MAX);
      if (state.on) fit(ta);
    }
    /* the note box grows with the text (86px min, 260px max) so the counter never sits on the words */
    function fit(ta) {
      if (!ta || !ta.offsetParent) return;
      ta.style.height = 'auto';
      ta.style.height = Math.max(86, Math.min(260, ta.scrollHeight + 2)) + 'px';
    }

    /* ---- saving: debounced, one retry, never blocks anything ---- */
    function queue(ms) { dirty = true; clearTimeout(timer); timer = setTimeout(flush, ms); }
    function payload() {
      var a = {}; a[KEY_ON] = state.on ? YES : ''; a[KEY_MSG] = state.on ? state.msg.trim().slice(0, MAX) : '';
      return { attributes: a };
    }
    function flush() {
      if (!dirty || saving) return;
      dirty = false; saving = true;
      post(0);
    }
    function post(attempt) {
      var f = window.fetch; if (!f) { saving = false; return; }
      f('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload())
      }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function () { saving = false; if (dirty) flush(); })
        .catch(function () {
          if (attempt < 1) { setTimeout(function () { post(attempt + 1); }, 1200); return; }
          saving = false; dirty = true;                 /* keep the UI as it is; the next touch tries again and the form fields carry the values anyway */
        });
    }

    /* ---- reading the saved state back ---- */
    function apply(c) {
      if (!c || typeof c !== 'object' || !c.attributes) return;
      if (dirty || saving) return;                    /* local edits win */
      var a = c.attributes;
      state.on = a[KEY_ON] === YES;
      state.msg = String(a[KEY_MSG] || '').slice(0, MAX);
      paint();
    }
    function load() {
      if (loading || !window.fetch) return;
      loading = true;
      window.fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(apply).catch(function () {})
        .then(function () { loading = false; });
    }

    /* ---- events (delegated, so a drawer re-render cannot lose them) ---- */
    function isTa(t) { return t && t.classList && t.classList.contains('brgw__ta'); }
    d.addEventListener('click', function (e) {
      var sw = e.target && e.target.closest ? e.target.closest('.brgw__sw') : null;
      if (!sw) return;
      e.preventDefault();
      state.on = !state.on;
      var el = d.getElementById('brgw'), ta = el && el.querySelector('.brgw__ta');
      if (ta) state.msg = ta.value.slice(0, MAX);
      paint();
      queue(0);
    });
    d.addEventListener('input', function (e) {
      if (!isTa(e.target)) return;
      var v = e.target.value;
      if (v.length > MAX) { v = v.slice(0, MAX); e.target.value = v; }
      state.msg = v;
      paint();
      queue(DEBOUNCE);
    });
    d.addEventListener('focusout', function (e) {
      if (!isTa(e.target)) return;
      state.msg = e.target.value.slice(0, MAX);
      if (dirty) queue(0);
    });
    d.addEventListener('br:cart', function (e) { apply(e.detail); });

    /* ---- keep the block present and fresh ---- */
    function ensure() { mount(); paint(); }
    var wasOpen = false;
    function tick() {
      ensure();
      var open = d.body.classList.contains('drawer--active');
      if (open && !wasOpen) load();               /* re-read the saved state every time the bag opens */
      wasOpen = open;
    }
    function boot() {
      try {
        if (!mount()) { if (!d.querySelector('.drawer') && !isCartPage()) return; }
        if (isCartPage()) load();
        var drawer = d.querySelector('.drawer');
        if (window.MutationObserver) {
          var h;
          var mo = new MutationObserver(function () { clearTimeout(h); h = setTimeout(tick, 60); });
          if (drawer) mo.observe(drawer, { childList: true, subtree: true });
          mo.observe(d.body, { attributes: true, attributeFilter: ['class'] });
        }
        setInterval(tick, 2000);
        window.addEventListener('pageshow', function (ev) { if (ev.persisted) { dirty = false; saving = false; load(); } });
        tick();
      } catch (e) {}
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  } catch (e) {}
})();

/* ===== BR CAROUSEL-HOME 26 SEP =====
   A. Product page: "You may also like" -> swipe row (same as the homepage best sellers), small line above a big
      serif heading. The Liquid edit in sections/you-may-also-like.liquid prints the heading; this script is the
      fallback (adds the class, the small line and the wording if the Liquid edit is missing) and it always adds the
      scroll wrapper and the desktop arrows.
   B. Homepage: if sections/br-maison.liquid still prints the old words, rewrite "Loved most" / "Best sellers"
      to "Bestsellers" / "Most loved". Any other wording set in the theme editor is left alone.
   Does nothing on pages without these sections. Never throws. */
(function () {
  'use strict';
  var BRC_TITLE = 'Second love';          /* product page: the big heading. Switch here to 'Second Love' if wanted. */
  var BRC_EYEBROW = 'You may also like';  /* product page: the small uppercase line above it */
  var BRH_TITLE = 'Most loved';           /* homepage: the big heading (fallback only, see B above) */
  var BRH_EYEBROW = 'Bestsellers';        /* homepage: the small uppercase line above it (fallback only) */
  var d = document;

  function arrow(dir, label, glyph) {
    var b = d.createElement('button');
    b.type = 'button'; b.className = 'brc-arrow brc-arrow--' + dir; b.setAttribute('aria-label', label); b.innerHTML = glyph;
    return b;
  }

  /* A · product page */
  function pdp() {
    var sec = d.querySelector('.you_may_also_like_product');
    if (!sec) return;
    sec.classList.add('brc-on');

    /* heading: Liquid prints it; this fixes it up if the Liquid edit is not there, and applies BRC_TITLE */
    var head = sec.querySelector('.section-header');
    var h2 = head && head.querySelector('h2');
    if (h2) {
      h2.classList.add('brc-title');
      if (h2.textContent.trim() !== BRC_TITLE) h2.textContent = BRC_TITLE;
      var eb = head.querySelector('.brc-eyebrow');
      if (!eb) { eb = d.createElement('span'); eb.className = 'brc-eyebrow'; head.insertBefore(eb, h2); }
      if (eb.textContent.trim() !== BRC_EYEBROW) eb.textContent = BRC_EYEBROW;
    }

    /* row: wrap the existing card list (cards are moved, not re-created, so the theme's own click handlers stay) */
    var row = sec.querySelector('.card-list');
    if (!row || sec.querySelector('.brc-wrap')) return;
    var wrap = d.createElement('div'); wrap.className = 'brc-wrap';
    row.parentNode.insertBefore(wrap, row);
    var prev = arrow('prev', 'Previous', '&#8249;'), next = arrow('next', 'Next', '&#8250;');
    wrap.appendChild(prev); wrap.appendChild(row); wrap.appendChild(next);
    var step = function () { var c = row.querySelector('.covered_like'); return c ? c.getBoundingClientRect().width + 20 : 300; };
    prev.addEventListener('click', function () { row.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    var fit = function () { wrap.classList.toggle('is-scroll', row.scrollWidth > row.clientWidth + 2); };
    fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
    if (window.BRBW && typeof window.BRBW.initCards === 'function') window.BRBW.initCards(sec);
  }

  /* B · homepage heading fallback */
  function home() {
    var head = d.querySelector('.br-best .br-best__head');
    if (!head) return;
    var t = head.querySelector('.br-best__title');
    if (t && /^best sellers$/i.test(t.textContent.trim())) t.textContent = BRH_TITLE;
    var eb = head.querySelector('.br-eyebrow');
    if (!eb && t) { eb = d.createElement('span'); eb.className = 'br-eyebrow'; eb.textContent = BRH_EYEBROW; head.insertBefore(eb, t); }
    else if (eb && /^loved most$/i.test(eb.textContent.trim())) eb.textContent = BRH_EYEBROW;
  }

  function boot() {
    try { pdp(); } catch (e) {}
    try { home(); } catch (e) {}
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* ===== END BR CAROUSEL-HOME 26 SEP ===== */
/* ===== BR STORES 30 SEP =====
   Our Stores hub (/pages/retail-store): on each store card the address becomes a Google Maps link, the hours line
   becomes "today's hours + open/closed now (India time)" with "Open daily" under it, and three pill buttons are
   added: Call (tel:), WhatsApp (wa.me), Directions (Google Maps). A soft line goes under the cards.
   On the hub and on the three store pages a JewelryStore JSON-LD block is added (telephone, address, opening hours).
   Numbers, links and hours are the ones already on the store pages. To switch off: delete this block (and the
   BR STORES block in br-bw.css). */
(function () {
  var d = document, root = window;
  var HOLD_NOTE = 'Message the store to hold a piece before you come.';
  var STORES = {
    '/pages/kala-ghoda': {
      name: 'Bhavya Ramesh Kala Ghoda', short: 'Kala Ghoda, Mumbai', phone: '+91 83020 74284', tel: '+918302074284', wa: '918302074284',
      street: 'Ground Floor, Shop No 3, 43 Forbes Street, Kala Ghoda, Fort', city: 'Mumbai', region: 'Maharashtra', pin: '400023',
      q: 'Bhavya Ramesh, 43 Forbes Street, Kala Ghoda, Fort, Mumbai 400023', open: '11:00', close: '21:30',
      image: 'https://cdn.shopify.com/s/files/1/2675/8584/files/kala-ghoda.jpg?v=1772368349'
    },
    '/pages/bandra': {
      name: 'Bhavya Ramesh Bandra', short: 'Bandra West, Mumbai', phone: '+91 83699 72706', tel: '+918369972706', wa: '918369972706',
      street: 'Shop No 5, Sunbeam CHS, Perry Cross Road, Bandra West', city: 'Mumbai', region: 'Maharashtra', pin: '400050',
      q: 'Bhavya Ramesh, Sunbeam CHS, Perry Cross Road, Bandra West, Mumbai 400050', open: '11:00', close: '20:30',
      image: 'https://cdn.shopify.com/s/files/1/2675/8584/files/bandra.jpg?v=1772368236'
    },
    '/pages/khan-market': {
      name: 'Bhavya Ramesh Khan Market', short: 'Khan Market, New Delhi', phone: '+91 92175 05492', tel: '+919217505492', wa: '919217505492',
      street: 'Shop No 40A, Ground Floor, Khan Market, Rabindra Nagar', city: 'New Delhi', region: 'Delhi', pin: '110003',
      q: 'Bhavya Ramesh, Shop 40A, Khan Market, Rabindra Nagar, New Delhi 110003', open: '11:00', close: '21:00',
      image: 'https://cdn.shopify.com/s/files/1/2675/8584/files/khan-market.jpg?v=1772368235'
    }
  };
  var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  var ICON = {
    call: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/></svg>',
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20l1.3-3.8A8 8 0 1 1 8.2 19z"/><path d="M9.5 9.5c0 3 2.5 5.5 5.5 5.5l1-1.5-2-1-1 1a4 4 0 0 1-2-2l1-1-1-2z"/></svg>',
    dir: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l10 10-10 10L2 12z"/><path d="M9 14v-3h5"/><path d="M12 9l2 2-2 2"/></svg>'
  };
  function mapsSearch(s) { return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.q); }
  function mapsDir(s) { return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.q); }
  function fmt(hm) { var p = hm.split(':'), h = +p[0], m = p[1]; var ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + ':' + m + ' ' + ap; }
  function istNow() { /* minutes since midnight, India time; null if the browser cannot do time zones */
    try { var s = new Date().toLocaleTimeString('en-GB', { timeZone: 'Asia/Kolkata', hour12: false, hour: '2-digit', minute: '2-digit' }); var p = s.match(/(\d+):(\d+)/); return p ? (+p[1] % 24) * 60 + +p[2] : null; } catch (e) { return null; }
  }
  function mins(hm) { var p = hm.split(':'); return +p[0] * 60 + +p[1]; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function el(html) { var t = d.createElement('div'); t.innerHTML = html; return t.firstElementChild; }

  function hoursLine(s) { /* "Open now \u00b7 closes 9:30 pm" or "Closed now \u00b7 opens 11:00 am" (India time); plain today's hours if the browser cannot tell the zone */
    var now = istNow(), cls = 'brst-hrs', html;
    if (now === null) html = esc('Today ' + fmt(s.open) + ' \u2013 ' + fmt(s.close));
    else if (now >= mins(s.open) && now < mins(s.close)) html = '<span class="brst-dot"></span><span class="brst-state">Open now</span> \u00b7 closes ' + esc(fmt(s.close));
    else { cls += ' is-closed'; html = '<span class="brst-dot"></span><span class="brst-state">Closed now</span> \u00b7 opens ' + esc(fmt(s.open)); }
    return el('<p class="' + cls + '">' + html + '</p>');
  }

  function enhanceCard(card, s) {
    var body = card.querySelector('.br-store__card-body'); if (!body || body.querySelector('.brst-btns')) return;
    var addr = body.querySelector('.br-store__addr');
    if (addr && !addr.querySelector('a.brst-addr')) {
      var a = d.createElement('a'); a.className = 'brst-addr'; a.href = mapsSearch(s); a.target = '_blank'; a.rel = 'noopener';
      a.setAttribute('aria-label', 'Open ' + s.short + ' in Google Maps');
      while (addr.firstChild) a.appendChild(addr.firstChild);
      addr.appendChild(a);
    }
    var hrs = body.querySelector('.br-store__hrs');
    var line = hoursLine(s), daily = el('<p class="brst-daily">Open daily \u00b7 ' + esc(fmt(s.open) + ' \u2013 ' + fmt(s.close)) + '</p>');
    var btns = el('<div class="brst-btns">' +
      '<a class="brst-btn" href="tel:' + s.tel + '" aria-label="Call ' + esc(s.short) + ' on ' + esc(s.phone) + '">' + ICON.call + 'Call</a>' +
      '<a class="brst-btn" href="https://wa.me/' + s.wa + '" target="_blank" rel="noopener" aria-label="WhatsApp ' + esc(s.short) + '">' + ICON.wa + 'WhatsApp</a>' +
      '<a class="brst-btn brst-btn--dir" href="' + mapsDir(s) + '" target="_blank" rel="noopener" aria-label="Get directions to ' + esc(s.short) + '">' + ICON.dir + 'Get directions</a></div>');
    var go = body.querySelector('.br-store__go');
    if (hrs) { hrs.parentNode.insertBefore(line, hrs); hrs.parentNode.insertBefore(daily, hrs); hrs.parentNode.removeChild(hrs); }
    else if (go) { body.insertBefore(line, go); body.insertBefore(daily, go); }
    else { body.appendChild(line); body.appendChild(daily); }
    if (go) body.insertBefore(btns, go); else body.appendChild(btns);
  }

  function jsonld(list) {
    if (d.getElementById('brst-jsonld')) return;
    var has = false; d.querySelectorAll('script[type="application/ld+json"]').forEach(function (x) { if (/#store"/.test(x.text || '')) has = true; }); if (has) return;   /* the theme already declares the three stores (Organization > location): do not repeat them */
    var graph = list.map(function (s) {
      return { '@type': 'JewelryStore', '@id': 'https://bhavyaramesh.com' + s.path + '#store', name: s.name, image: s.image,
        url: 'https://bhavyaramesh.com' + s.path, telephone: s.phone.replace(/\s+/g, ''),
        address: { '@type': 'PostalAddress', streetAddress: s.street, addressLocality: s.city, addressRegion: s.region, postalCode: s.pin, addressCountry: 'IN' },
        openingHoursSpecification: [{ '@type': 'OpeningHoursSpecification', dayOfWeek: DAYS, opens: s.open, closes: s.close }],
        hasMap: mapsSearch(s), currenciesAccepted: 'INR', paymentAccepted: 'Cash, Credit Card, UPI',
        parentOrganization: { '@type': 'Organization', name: 'Bhavya Ramesh', url: 'https://bhavyaramesh.com' } };
    });
    var sc = d.createElement('script'); sc.type = 'application/ld+json'; sc.id = 'brst-jsonld';
    sc.text = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
    d.head.appendChild(sc);
  }

  function boot() {
    try {
      var path = location.pathname.slice(-1) === '/' ? location.pathname.slice(0, -1) : location.pathname;
      var wrap = d.querySelector('.br-store');
      if (!wrap) return;
      if (wrap.querySelector('.br-store__grid')) {   /* the hub */
        var all = [];
        Object.keys(STORES).forEach(function (p) { var s = STORES[p]; s.path = p; all.push(s); });
        wrap.querySelectorAll('.br-store__card').forEach(function (card) {
          var go = card.querySelector('a.br-store__go'); var p = go && (go.getAttribute('href') || ''); if (p && p.slice(-1) === '/') p = p.slice(0, -1);
          if (p && STORES[p]) enhanceCard(card, STORES[p]);
        });
        var grid = wrap.querySelector('.br-store__grid');
        if (grid && !wrap.querySelector('.brst-note')) grid.parentNode.insertBefore(el('<p class="brst-note">' + esc(HOLD_NOTE) + '</p>'), grid.nextSibling);
        jsonld(all);
      } else if (STORES[path]) {                        /* a store page */
        var s = STORES[path]; s.path = path; jsonld([s]);
      }
    } catch (e) { if (root.console && console.warn) console.warn('BR STORES', e); }
  }
  root.BRStores = { boot: boot, STORES: STORES };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* ===== END BR STORES 30 SEP ===== */
/* ===== BR MOST LOVED 5 OCT ===== */
/* ==========================================================================================
   BRM · Bhavya Ramesh homepage — "Most loved" keeps moving to the left on its own
   Iteration B1 — "Glide"
   ------------------------------------------------------------------------------------------
   What it does
     The best-seller row (.br-best__row) drifts slowly to the left, for ever: a card that has
     left on the left side is quietly moved to the end of the row (no copies, so every card
     keeps its own buttons: wishlist, quick add, silver/gold). It rests while a finger or the
     mouse is on it and while it is off screen, and it can still be swiped or moved with the
     arrows; the drift resumes a moment after the visitor lets go.
   Settings
     RHYTHM 'glide' = continuous drift · 'step' = hold, then slide one card (like the reference video)
   Safety
     Does nothing when the row is missing or has fewer than three cards. Never throws.
     With "reduce motion" switched on in the phone settings it does not move on its own.
     Runs once; running it again replaces the previous copy (window.__brm.destroy).
   ========================================================================================== */
(function () {
  'use strict';
  var MODE = 'glide';          /* 'glide' = B1 (the cards as they are) · 'film' = B2 (edge-to-edge filmstrip, words under the centre card) */
  var RHYTHM = 'glide';        /* 'glide' | 'step' */
  var SPEED_PHONE = 26;  /* px per second on a phone   (glide) */
  var SPEED_DESK = 38;    /* px per second on a computer (glide) */
  var STEP_EVERY = 4000;          /* ms between moves (step) */
  var STEP_TIME = 650;            /* ms one move takes (step) */
  var RESUME_AFTER = 2400;        /* ms after the visitor lets go before it moves again */
  var d = document, w = window;

  function init() {
    var best = d.querySelector('.br-best'); if (!best) return;
    var row = best.querySelector('.br-best__row'); if (!row) return;
    if (row.querySelectorAll('.br-best__card').length < 3) return;
    if (w.__brm && w.__brm.destroy) { try { w.__brm.destroy(); } catch (e) {} }
    var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
    best.classList.add('brm', 'brm--' + MODE);

    var pos = row.scrollLeft, expect = pos, raf = 0, last = 0, dead = false;
    var touching = false, hover = false, userUntil = 0, onScreen = true, settle = 0, centreEl = null;
    var stepAt = 0, stepT0 = 0, stepFrom = 0, stepTo = 0, wasActive = false, frames = 0;

    function now() { return (w.performance && performance.now) ? performance.now() : Date.now(); }
    function speed() { return w.innerWidth < 768 ? SPEED_PHONE : SPEED_DESK; }
    function gap() { var cs = getComputedStyle(row); return parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0; }
    function stepW() { var c = row.querySelector('.br-best__card'); return c ? c.getBoundingClientRect().width + gap() : 0; }
    function set(x) { pos = x; expect = x; row.scrollLeft = x; }

    /* cards that have fully left on the left go to the end; the view does not move */
    function recycleForward() {
      var g = gap(), rl = row.getBoundingClientRect().left, guard = 0;
      while (guard++ < 30) {
        var first = row.firstElementChild; if (!first) break;
        var r = first.getBoundingClientRect();
        if (r.right + g > rl) break;
        row.appendChild(first);
        set(row.scrollLeft - (r.width + g));
      }
    }
    /* the visitor swiped back to the start: bring cards round from the end so there is always something before */
    function recycleBack() {
      var guard = 0, sw = stepW();
      while (guard++ < 30 && sw && row.scrollLeft < sw) {
        var lastC = row.lastElementChild; if (!lastC) break;
        row.insertBefore(lastC, row.firstElementChild);
        set(row.scrollLeft + sw);
      }
    }
    /* B2: which card sits in the middle of the screen */
    function centre() {
      var rr = row.getBoundingClientRect(), cx = rr.left + rr.width / 2, bestC = null, bd = 1e9, cs = row.children;
      for (var i = 0; i < cs.length; i++) {
        var r = cs[i].getBoundingClientRect(); if (r.right < rr.left || r.left > rr.right) continue;
        var dd = Math.abs(r.left + r.width / 2 - cx); if (dd < bd) { bd = dd; bestC = cs[i]; }
      }
      if (bestC !== centreEl) { if (centreEl) centreEl.classList.remove('brm-centre'); centreEl = bestC; if (bestC) bestC.classList.add('brm-centre'); }
    }

    function frame(t) {
      if (dead) return;
      raf = requestAnimationFrame(frame); frames++;
      var dt = last ? Math.min(50, t - last) : 0; last = t;
      var active = onScreen && !d.hidden && !touching && !hover && t >= userUntil && !reduce;
      if (MODE === 'film') centre();
      if (active && !wasActive) { pos = expect = row.scrollLeft; }   /* carry on from wherever it is */
      wasActive = active;
      if (!active) { stepT0 = 0; stepAt = 0; return; }
      if (RHYTHM === 'step') {
        if (!stepT0) { if (!stepAt) stepAt = t + STEP_EVERY; if (t >= stepAt) { stepT0 = t; stepFrom = pos; stepTo = pos + stepW(); } }
        if (stepT0) {
          var k = Math.min(1, (t - stepT0) / STEP_TIME), e = k < .5 ? 2 * k * k : -1 + (4 - 2 * k) * k;
          pos = stepFrom + (stepTo - stepFrom) * e;
          if (k >= 1) { stepT0 = 0; stepAt = t + STEP_EVERY; }
        }
      } else {
        pos += speed() * dt / 1000;
      }
      expect = pos; row.scrollLeft = pos;
      recycleForward();
    }

    /* the visitor moved it (finger, wheel, arrows): rest, then carry on from where they left it */
    function onScroll() {
      if (Math.abs(row.scrollLeft - expect) <= 2) return;   /* that was us */
      pos = expect = row.scrollLeft; userUntil = now() + RESUME_AFTER; stepT0 = 0; stepAt = 0;
      clearTimeout(settle);
      settle = setTimeout(function () { if (dead) return; pos = expect = row.scrollLeft; recycleForward(); recycleBack(); }, 160);
      /* about to hit the end wall: bring cards round now */
      if (row.scrollLeft > row.scrollWidth - row.clientWidth - stepW()) { recycleForward(); }
    }
    function onTS() { touching = true; }
    function onTE() { touching = false; userUntil = now() + RESUME_AFTER; }
    function onEnter(e) { if (!e.pointerType || e.pointerType === 'mouse') hover = true; }
    function onLeave(e) { if (!e.pointerType || e.pointerType === 'mouse') hover = false; }
    function onResize() { pos = expect = row.scrollLeft; }

    row.addEventListener('scroll', onScroll, { passive: true });
    row.addEventListener('touchstart', onTS, { passive: true });
    row.addEventListener('touchend', onTE, { passive: true });
    row.addEventListener('touchcancel', onTE, { passive: true });
    best.addEventListener('pointerenter', onEnter); best.addEventListener('pointerleave', onLeave);
    w.addEventListener('resize', onResize);
    var io = null;
    if (w.IntersectionObserver) { io = new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }, { rootMargin: '80px' }); io.observe(best); }

    w.__brmT0 = now();
    raf = requestAnimationFrame(frame);

    w.__brm = {
      mode: MODE,
      reset: function () { set(0); userUntil = 0; stepT0 = 0; stepAt = 0; if (MODE === 'film') centre(); },
      state: function () { return { frames: frames, dead: dead, pos: pos, touching: touching, hover: hover, waiting: Math.max(0, userUntil - now()), onScreen: onScreen, reduce: reduce, hidden: d.hidden }; },
      destroy: function () {
        dead = true; cancelAnimationFrame(raf); clearTimeout(settle);
        row.removeEventListener('scroll', onScroll); row.removeEventListener('touchstart', onTS);
        row.removeEventListener('touchend', onTE); row.removeEventListener('touchcancel', onTE);
        best.removeEventListener('pointerenter', onEnter); best.removeEventListener('pointerleave', onLeave);
        w.removeEventListener('resize', onResize); if (io) io.disconnect();
        if (centreEl) centreEl.classList.remove('brm-centre');
        best.classList.remove('brm', 'brm--' + MODE); w.__brm = null;
      }
    };
  }

  function boot() { try { init(); } catch (e) { /* never break the page */ } }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* ===== END BR MOST LOVED 5 OCT ===== */
/* ===== BR LOTUS TAP 5 OCT ===== */
/* ===== BRK · lotus tap effect · WATERFALL (5 Oct 2026, replaces the 3 Oct burst and the 5 Oct bloom) =====
   Every tap on a phone, or left click on a computer, pours a soft stream of tiny lotus petals from the
   point that was touched. Nothing sprays outwards: the petals spill over a short rim one after another
   for about a second and a half and fall like a waterfall - starting slowly, gathering a gentle, steady speed,
   fluttering and turning as they go, the stream widening a little as it falls - then fade away about
   two hundred pixels below. The whole fall runs at PACE (0.7 = 30 % slower than the first waterfall,
   as asked on 5 Oct): same path and length, it just takes longer. Each pour differs a little
   (count, width, speed, flutter, breeze).
   Safety: one see-through drawing layer above the page that never catches a tap; off in the
   Shopify theme editor; off when the visitor's device asks for reduced motion; right clicks and
   second fingers ignored; on a phone only a real tap pours petals (a finger that scrolls,
   swipes or long-presses does not); never more than MAX_PETALS petals on screen; the layer hides itself
   when idle. To switch it off, delete this block (and the BRK block in br-bw.css). */
(function () {
  'use strict';

  /* ---- the numbers that shape the effect (each is a one-number change) ---------------------- */
  var PETALS_PER_TAP = [64, 84];      /* how many petals one tap pours                             */
  var MAX_PETALS     = 320;           /* hard cap on screen at once                                 */
  var PETAL_LENGTH   = [3.85, 7.7];   /* px, base to tip (30 % smaller than the 3 Oct 5.5-11)        */
  var RIM            = 14;            /* px, half the width of the rim the petals spill over        */
  var POUR           = 1.5;           /* s, how long the stream keeps pouring after a tap           */
  var START_SPEED    = [15, 35];      /* px/s, downward speed as a petal leaves the rim             */
  var FALL_SPEED     = [100, 135];    /* px/s, the steady speed it settles into (air slows it)      */
  var DRAG           = [0.9, 1.3];    /* how quickly it reaches that steady speed                   */
  var SPREAD         = [6, 30];       /* px/s, how much the outer petals drift outwards as they fall */
  var LIFE           = [1.7, 2.3];    /* seconds each petal lives at PACE 1                          */
  var PACE           = 0.7;           /* 1 = first waterfall; 0.7 = 30 % slower fall, flutter and turn;
                                         petals live 1/PACE longer so they still fall the same distance */
  var FINGER_SPREAD  = 1.12;          /* a fingertip hides more than a mouse arrow: open wider     */
  var PINKS = [                       /* three soft pinks: base, body, pale tip                    */
    ['#E27F9F', '#EE9FB8', '#FCE6ED'],
    ['#EC97B1', '#F5BBCC', '#FFF1F5'],
    ['#F1AEC2', '#F9D0DC', '#FFF7F9']
  ];
  var PINK_SHARE     = [0.35, 0.40, 0.25];   /* how often each pink is used                        */
  var DPR_CAP        = 2;             /* drawing sharpness cap (keeps memory low on 3x phones)     */
  var MAX_PIXELS     = 4000000;       /* layer size cap for very large screens (about 16 MB)       */
  /* -------------------------------------------------------------------------------------------- */

  var w = window, d = document;
  try {
    if (w.Shopify && w.Shopify.designMode) return;                 /* theme editor               */
    var path = location.pathname;
    if (path === '/admin' || path.indexOf('/admin/') === 0) return;  /* Shopify admin              */
    var api = w.BRK = w.BRK || {};
    if (api.bound) return;                                          /* pasted twice: run once     */
    var probe = d.createElement('canvas');
    if (!probe.getContext || !probe.getContext('2d')) return;       /* very old browser: nothing  */
    probe = null;

    var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var cv = null, ctx = null, dpr = 1, vw = 0, vh = 0, raf = 0, idle = 0;
    var live = [], sprites = null, spriteDpr = 0, spriteLen = 0;
    var density = 1, ema = 0, lastT = 0, box = null, nb = [0, 0, 0, 0];
    var PI = Math.PI, TAU = PI * 2, DEG = PI / 180, exp = Math.exp, sin = Math.sin, cos = Math.cos;

    /* BRK.clock is only ever set by the preview pictures (to freeze a moment); never on the site */
    function now() { return api.clock ? api.clock() : (w.performance && performance.now ? performance.now() : Date.now()); }
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function pick(r) { return rnd(r[0], r[1]); }
    function sign() { return Math.random() < 0.5 ? -1 : 1; }
    function bell() { return (Math.random() + Math.random() + Math.random() - 1.5) * 2; }   /* soft bell curve, -3..3 */

    /* ---- one petal, drawn once per colour and reused: narrow base, widest just above the middle,
           long pointed tip, slightly cupped (light on one side, shade on the other), a hint of a
           centre vein, a fine deeper-pink rim so it reads on pale photos too ---- */
    function petalPath(g, L, W) {
      var h = W / 2;
      g.beginPath();
      g.moveTo(0, 0);
      g.bezierCurveTo(h * 0.38, 0, h * 1.0, -L * 0.32, h, -L * 0.6);
      g.bezierCurveTo(h * 1.0, -L * 0.78, h * 0.36, -L * 0.9, 0, -L);
      g.bezierCurveTo(-h * 0.36, -L * 0.9, -h * 1.0, -L * 0.78, -h, -L * 0.6);
      g.bezierCurveTo(-h * 1.0, -L * 0.32, -h * 0.38, 0, 0, 0);
      g.closePath();
    }
    function makeSprite(col, slim, back, L) {
      var W = L * (slim ? 0.32 : 0.4), pad = 2, c = d.createElement('canvas');
      c.width = Math.ceil(W + pad * 2); c.height = Math.ceil(L + pad * 2);
      var g = c.getContext('2d'), s = back ? -1 : 1;
      g.translate(c.width / 2, pad + L);
      petalPath(g, L, W);
      var lg = g.createLinearGradient(0, 0, 0, -L);
      lg.addColorStop(0, col[0]); lg.addColorStop(0.45, col[1]); lg.addColorStop(1, col[2]);
      g.fillStyle = lg; g.fill();
      g.save(); g.clip();
      var cg = g.createLinearGradient(-s * W / 2, 0, s * W / 2, 0);
      cg.addColorStop(0, 'rgba(255,255,255,' + (back ? 0.18 : 0.42) + ')');
      cg.addColorStop(0.45, 'rgba(255,255,255,0)');
      cg.addColorStop(0.7, 'rgba(176,52,98,0)');
      cg.addColorStop(1, 'rgba(186,64,108,' + (back ? 0.24 : 0.18) + ')');
      g.fillStyle = cg; g.fillRect(-W, -L - 2, W * 2, L + 4);
      g.restore();
      g.beginPath(); g.moveTo(0, -L * 0.1); g.quadraticCurveTo(W * 0.06, -L * 0.48, 0, -L * 0.84);
      g.strokeStyle = 'rgba(255,255,255,' + (back ? 0.25 : 0.5) + ')'; g.lineWidth = Math.max(0.5, L * 0.025); g.stroke();
      petalPath(g, L, W);
      g.strokeStyle = 'rgba(226,120,156,0.4)'; g.lineWidth = Math.max(0.45, L * 0.025); g.stroke();
      return c;
    }
    function buildSprites() {
      spriteLen = Math.ceil(PETAL_LENGTH[1] * dpr * 1.05);
      sprites = [];
      for (var i = 0; i < PINKS.length; i++)
        sprites.push([[makeSprite(PINKS[i], 0, 0, spriteLen), makeSprite(PINKS[i], 0, 1, spriteLen)],
                      [makeSprite(PINKS[i], 1, 0, spriteLen), makeSprite(PINKS[i], 1, 1, spriteLen)]]);
      spriteDpr = dpr;
    }

    /* ---- the single drawing layer: created on the first tap, sized to the screen, hidden when idle ---- */
    function ensure() {
      if (!cv || !cv.isConnected) {
        cv = d.createElement('canvas');
        cv.className = 'brk-layer';
        cv.setAttribute('aria-hidden', 'true');
        ctx = cv.getContext('2d');
        if (!ctx) { cv = null; return false; }
        (d.body || d.documentElement).appendChild(cv);
        vw = vh = 0;
      }
      var W = w.innerWidth || d.documentElement.clientWidth, H = w.innerHeight || d.documentElement.clientHeight;
      var r = Math.min(w.devicePixelRatio || 1, DPR_CAP, Math.sqrt(MAX_PIXELS / (W * H)));
      r = Math.max(1, Math.round(r * 100) / 100);
      if (!W || !H) return false;
      if (W !== vw || H !== vh || r !== dpr) {
        vw = W; vh = H; dpr = r;
        cv.width = Math.round(W * r); cv.height = Math.round(H * r);
        box = [0, 0, cv.width, cv.height];
      }
      cv.style.cssText = 'position:fixed;left:0;top:0;width:' + W + 'px;height:' + H + 'px;z-index:2147483000;pointer-events:none;'
        + 'margin:0;padding:0;border:0;max-width:none;max-height:none;background:transparent;display:block';
      if (spriteDpr !== dpr || !sprites) buildSprites();
      clearTimeout(idle);
      return true;
    }
    function sleep() {
      raf = 0; lastT = 0;
      if (!cv) return;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height); box = null;
      cv.style.display = 'none';
      clearTimeout(idle);
      idle = setTimeout(function () {                                /* free the memory after a quiet spell */
        try { if (!live.length && cv && !raf) { cv.width = cv.height = 1; vw = vh = 0; } } catch (e) {}
      }, 8000);
    }

    /* ---- one tap: a short rim at the touch point, petals spill over it one after another ---- */
    function spawn(x, y, kind) {
      if (!ensure()) return;
      var t0 = now(), spread = (kind === 'touch' || kind === 'pen') ? FINGER_SPREAD : 1;
      var n = Math.max(12, Math.round(pick(PETALS_PER_TAP) * density));
      var rim = RIM * spread * rnd(0.85, 1.15), wind = rnd(-5, 5);
      if (live.length + n > MAX_PETALS) live.splice(0, live.length + n - MAX_PETALS);   /* drop the oldest */
      for (var i = 0; i < n; i++) {
        var u = bell() / 3; if (u > 1) u = 1; if (u < -1) u = -1;    /* where along the rim: mostly the middle */
        var c = Math.random(), ci = c < PINK_SHARE[0] ? 0 : (c < PINK_SHARE[0] + PINK_SHARE[1] ? 1 : 2);
        live.push({
          b: t0, dl: i === 0 ? 0 : POUR * Math.pow(Math.random(), 1.1),    /* a steady pour, a little fuller at first */
          x: x + u * rim, y: y + 3 * u * u + rnd(-2, 2),
          vx: (u * pick(SPREAD) * spread + rnd(-5, 5)) * PACE, kx: rnd(1.3, 1.9) * PACE, wd: wind * rnd(0.6, 1.2) * PACE,   /* outer petals widen the fall */
          v0: pick(START_SPEED) * PACE, vT: pick(FALL_SPEED) * PACE, k: pick(DRAG) * PACE,   /* slow start, then a steady gentle fall */
          sw: rnd(1.5, 5), sf: rnd(2.2, 3.6) * PACE, sp: rnd(0, TAU),          /* flutter from side to side */
          r0: PI + bell() * 0.7, sr: rnd(0.3, 1.2) * sign() * PACE,            /* turns slowly as it falls */
          f0: bell() * 0.35, fr: rnd(0.8, 2.0) * sign() * PACE,                /* flips, showing its paler back */
          L: PETAL_LENGTH[0] + (PETAL_LENGTH[1] - PETAL_LENGTH[0]) * Math.pow(Math.random(), 1.25),
          ci: ci, sl: Math.random() < 0.5 ? 1 : 0, al: rnd(0.74, 0.94), life: pick(LIFE) / PACE
        });
      }
      if (!raf) raf = w.requestAnimationFrame(frame);
    }

    /* ---- position of one petal at time t (seconds after the tap); false when it is gone ---- */
    function draw(p, t) {
      var tt = t - p.dl;
      if (tt < 0) return true;
      if (tt > p.life) return false;
      var A = p.sw * (1 - exp(-tt * PACE / 0.6)), ph = p.sp + p.sf * tt;   /* flutter grows as it falls */
      var px = p.x + p.vx * (1 - exp(-p.kx * tt)) / p.kx + p.wd * tt + A * sin(ph);
      var py = p.y + p.vT * tt + (p.v0 - p.vT) * (1 - exp(-p.k * tt)) / p.k + 0.3 * A * sin(2 * ph);
      var rot = p.r0 + p.sr * tt, fl = cos(p.f0 + p.fr * tt), back = fl < 0 ? 1 : 0;
      fl = fl < 0 ? -fl : fl; if (fl < 0.2) fl = 0.2;
      var k = (tt - p.life * 0.6) / (p.life * 0.4), fade = k <= 0 ? 1 : 1 - k * k * (3 - 2 * k);
      var g = tt < 0.3 ? tt / 0.3 : 1; g = g * g * (3 - 2 * g);
      var sc = (0.6 + 0.4 * g) * (k > 0 ? 1 - 0.2 * k : 1);
      var fi = tt < 0.15 ? tt / 0.15 : 1;
      var a = p.al * fi * fi * (3 - 2 * fi) * fade;
      if (a <= 0.004) return true;
      var spr = sprites[p.ci][p.sl][back], m = p.L * dpr * sc / spriteLen;
      var cs = cos(rot), sn = sin(rot), ax = m * fl;
      var X = px * dpr, Y = py * dpr;
      if (X < nb[0]) nb[0] = X; if (X > nb[2]) nb[2] = X; if (Y < nb[1]) nb[1] = Y; if (Y > nb[3]) nb[3] = Y;
      ctx.globalAlpha = a;
      ctx.setTransform(cs * ax, sn * ax, -sn * m, cs * m, X, Y);
      ctx.drawImage(spr, -spr.width / 2, -spr.height / 2);
      return true;
    }
    function frame() {
      raf = 0;
      try {
        var t = now(), i, n = 0;
        if (lastT && live.length > 120) {                            /* slow phone? release fewer petals next time */
          var dt = t - lastT;
          if (dt > 0 && dt < 250) { ema = ema ? ema * 0.9 + dt * 0.1 : dt; if (ema > 28 && density > 0.5) { density -= 0.1; ema = 20; } }
        }
        lastT = t;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        if (box) ctx.clearRect(box[0], box[1], box[2] - box[0], box[3] - box[1]);   /* wipe only where petals were */
        nb[0] = nb[1] = 1e9; nb[2] = nb[3] = -1e9;
        for (i = 0; i < live.length; i++) if (draw(live[i], (t - live[i].b) / 1000)) live[n++] = live[i];
        var pad = spriteLen + 2;
        box = nb[2] < nb[0] ? null : [Math.max(0, Math.floor(nb[0] - pad)), Math.max(0, Math.floor(nb[1] - pad)), Math.min(cv.width, Math.ceil(nb[2] + pad)), Math.min(cv.height, Math.ceil(nb[3] + pad))];
        live.length = n;
        ctx.globalAlpha = 1;
        if (n || api.clock) raf = w.requestAnimationFrame(frame); else sleep();
      } catch (err) { live.length = 0; try { sleep(); } catch (e2) {} }
    }

    api.bloom = function (x, y, kind) { try { spawn(x, y, kind || 'touch'); } catch (e) {} };   /* for the demo page */
    api.redraw = function () { try { if (cv) { if (raf) w.cancelAnimationFrame(raf); frame(); } } catch (e) {} };
    api.bound = 'waterfall';

    /* a mouse click pours at once; a finger pours only when it lifts as a tap: it moved less than
       TAP_MOVE px and was down less than TAP_TIME ms (so scrolling the page never pours petals) */
    var TAP_MOVE = 10, TAP_TIME = 600, tap = null;
    function allowed(e) {
      if (mq && mq.matches) return false;                            /* reduced motion: nothing   */
      if (w.Shopify && w.Shopify.designMode) return false;
      if (e.button != null && e.button !== 0) return false;          /* right / middle click      */
      if (e.isPrimary === false) return false;                       /* second finger (pinch)     */
      if (e.ctrlKey && (!e.pointerType || e.pointerType === 'mouse')) return false;   /* Mac control-click = menu */
      return typeof e.clientX === 'number';
    }
    function far(p, x, y) { return !p || Math.abs(x - p.x) > TAP_MOVE || Math.abs(y - p.y) > TAP_MOVE; }
    function onDown(e) {
      try {
        tap = null;
        if (!allowed(e)) return;
        if (!e.pointerType || e.pointerType === 'mouse') { spawn(e.clientX, e.clientY, 'mouse'); return; }
        tap = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), k: e.pointerType };
      } catch (err) {}
    }
    function onMove(e) { if (tap && e.pointerId === tap.id && far(tap, e.clientX, e.clientY)) tap = null; }
    function onUp(e) {
      try {
        if (!tap || e.pointerId !== tap.id) return;
        var p = tap; tap = null;
        if (Date.now() - p.t > TAP_TIME || far(p, e.clientX, e.clientY)) return;
        spawn(p.x, p.y, p.k);
      } catch (err) {}
    }
    function onCancel() { tap = null; }                              /* the browser took the finger to scroll */
    var opt = { passive: true, capture: true };
    if (w.PointerEvent) {
      d.addEventListener('pointerdown', onDown, opt);
      d.addEventListener('pointermove', onMove, opt);
      d.addEventListener('pointerup', onUp, opt);
      d.addEventListener('pointercancel', onCancel, opt);
    } else {
      var lastTouch = 0;
      d.addEventListener('touchstart', function (e) {
        try {
          lastTouch = Date.now(); tap = null;
          if (mq && mq.matches) return;
          if (e.touches && e.touches.length > 1) return;
          var t = e.changedTouches && e.changedTouches[0];
          if (t) tap = { id: 1, x: t.clientX, y: t.clientY, t: Date.now(), k: 'touch' };
        } catch (err) {}
      }, opt);
      d.addEventListener('touchmove', function (e) { var t = e.changedTouches && e.changedTouches[0]; if (t && far(tap, t.clientX, t.clientY)) tap = null; }, opt);
      d.addEventListener('touchend', function (e) {
        try {
          lastTouch = Date.now();
          var p = tap; tap = null;
          if (p && Date.now() - p.t <= TAP_TIME) spawn(p.x, p.y, 'touch');
        } catch (err) {}
      }, opt);
      d.addEventListener('touchcancel', function () { tap = null; }, opt);
      d.addEventListener('mousedown', function (e) { if (Date.now() - lastTouch > 800) onDown(e); }, opt);
    }
  } catch (e) {}
})();
/* ===== END BR LOTUS TAP 5 OCT ===== */
